export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  Email: any,
  /** Timestamp as RFC3339-formatted string */
  Time: any,
  /** Represents untyped JSON */
  JSON: any,
};


export type Account = Node & {
  __typename: 'Account',
  readonly availablePlans: ReadonlyArray<Plan>,
  readonly availableReviewCount?: Maybe<Scalars['Int']>,
  readonly canStartTrial: Scalars['Boolean'],
  readonly hasTrialed: Scalars['Boolean'],
  readonly id: Scalars['ID'],
  readonly owner: AccountOwner,
  readonly screenLimit?: Maybe<Scalars['Int']>,
};

/** The connection type for Account. */
export type AccountConnection = {
  __typename: 'AccountConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<AccountEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Account>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
};

/** An edge in a connection. */
export type AccountEdge = {
  __typename: 'AccountEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<Account>,
};

export type AccountOwner = Organization | User;

/** Autogenerated input type of AddNoteToStudy */
export type AddNoteToStudyInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly note: Scalars['String'],
  readonly studyId: Scalars['ID'],
};

/** Autogenerated return type of AddNoteToStudy */
export type AddNoteToStudyPayload = MutationResultInterface & {
  __typename: 'AddNoteToStudyPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of AddReplyToComment */
export type AddReplyToCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  /** the content of the reply */
  readonly content: Scalars['String'],
  /** the id of the comment being replied to */
  readonly parentId: Scalars['ID'],
};

/** Autogenerated return type of AddReplyToComment */
export type AddReplyToCommentPayload = MutationResultInterface & {
  __typename: 'AddReplyToCommentPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of AddTagsToStudies */
export type AddTagsToStudiesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly studyIds: ReadonlyArray<Scalars['ID']>,
  readonly tags: ReadonlyArray<Scalars['String']>,
};

/** Autogenerated return type of AddTagsToStudies */
export type AddTagsToStudiesPayload = MutationResultInterface & {
  __typename: 'AddTagsToStudiesPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of AddUploadedDocument */
export type AddUploadedDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly filename: Scalars['String'],
  readonly referenceId: Scalars['ID'],
};

/** Autogenerated return type of AddUploadedDocument */
export type AddUploadedDocumentPayload = MutationResultInterface & {
  __typename: 'AddUploadedDocumentPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly documents?: Maybe<ReadonlyArray<Document>>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
  readonly url?: Maybe<Scalars['String']>,
};

/** Autogenerated input type of AssignOrganizationAdministratorToReview */
export type AssignOrganizationAdministratorToReviewInput = {
  readonly administratorId: Scalars['ID'],
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly reviewId: Scalars['ID'],
};

/** Autogenerated return type of AssignOrganizationAdministratorToReview */
export type AssignOrganizationAdministratorToReviewPayload = MutationResultInterface & {
  __typename: 'AssignOrganizationAdministratorToReviewPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly organization?: Maybe<Organization>,
  readonly review?: Maybe<Review>,
  readonly success: Scalars['Boolean'],
};

export type AuthorExport = Node & {
  __typename: 'AuthorExport',
  readonly authenticatedUrl?: Maybe<Scalars['String']>,
  readonly authorNameFilter?: Maybe<Scalars['String']>,
  readonly completedAt?: Maybe<Scalars['String']>,
  readonly createdAt: Scalars['String'],
  readonly failed: Scalars['Boolean'],
  readonly id: Scalars['ID'],
  readonly sortDirection: SortDirection,
};

/** Autogenerated input type of CancelInvitation */
export type CancelInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly invitationId: Scalars['ID'],
};

/** Autogenerated return type of CancelInvitation */
export type CancelInvitationPayload = MutationResultInterface & {
  __typename: 'CancelInvitationPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of CancelTopicExpertInvite */
export type CancelTopicExpertInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  /** id of the invite */
  readonly id: Scalars['ID'],
};

/** Autogenerated return type of CancelTopicExpertInvite */
export type CancelTopicExpertInvitePayload = MutationResultInterface & {
  __typename: 'CancelTopicExpertInvitePayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

export enum Category {
  /** Auto-excluded */
  Ae = 'AE',
  /** Duplicate */
  Dp = 'DP',
  /** Excluded */
  Ex = 'EX',
  /** Screening on full text */
  Ft = 'FT',
  /** Included */
  In = 'IN',
  /** Irrelevant */
  Ir = 'IR',
  /** Merged */
  Mg = 'MG',
  /** Screening on title & abstract */
  Ta = 'TA'
}

export type CategoryCounts = {
  __typename: 'CategoryCounts',
  readonly duplicate: Scalars['Int'],
  readonly excluded: Scalars['Int'],
  readonly included: Scalars['Int'],
  readonly irrelevant: Scalars['Int'],
  readonly merged: Scalars['Int'],
  readonly screen: Scalars['Int'],
  readonly select: Scalars['Int'],
};

/** Autogenerated input type of ChangeStudyIdentifier */
export type ChangeStudyIdentifierInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly newStudyIdentifier: Scalars['String'],
  readonly studyId: Scalars['ID'],
};

/** Autogenerated return type of ChangeStudyIdentifier */
export type ChangeStudyIdentifierPayload = MutationResultInterface & {
  __typename: 'ChangeStudyIdentifierPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly study?: Maybe<Study>,
  readonly success: Scalars['Boolean'],
};

export type Cochrane = {
  __typename: 'Cochrane',
  readonly isConnected: Scalars['Boolean'],
  readonly reviews: CochraneReviewConnection,
};


export type CochraneReviewsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  linkStatus?: Maybe<LinkStatus>
};

export type CochraneReview = Node & {
  __typename: 'CochraneReview',
  readonly cdNumber?: Maybe<Scalars['String']>,
  readonly cochraneId: Scalars['ID'],
  readonly id: Scalars['ID'],
  readonly link?: Maybe<CochraneReviewLink>,
  readonly title: Scalars['String'],
};

/** The connection type for CochraneReview. */
export type CochraneReviewConnection = {
  __typename: 'CochraneReviewConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CochraneReviewEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<CochraneReview>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
};

/** An edge in a connection. */
export type CochraneReviewEdge = {
  __typename: 'CochraneReviewEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<CochraneReview>,
};

export type CochraneReviewLink = Node & {
  __typename: 'CochraneReviewLink',
  readonly cochraneReview: CochraneReview,
  readonly covidenceReview: Review,
  readonly crsPendingStudiesCount?: Maybe<Scalars['Int']>,
  readonly id: Scalars['ID'],
};

export type Comment = Node & {
  __typename: 'Comment',
  readonly actions: CommentActions,
  readonly activeAgo: Scalars['String'],
  readonly activeBy: User,
  readonly content: Scalars['String'],
  readonly createdAgo: Scalars['String'],
  readonly editedAgo?: Maybe<Scalars['String']>,
  readonly id: Scalars['ID'],
  readonly mentions: ReadonlyArray<CommentMention>,
  readonly replies?: Maybe<ReadonlyArray<Comment>>,
  readonly resolvedAgo?: Maybe<Scalars['String']>,
  readonly reviewStudies: ReadonlyArray<Study>,
  readonly reviewer: User,
};

/** URLs for user actions that can be taken on this comment and urls for some. */
export type CommentActions = {
  __typename: 'CommentActions',
  /** can the user edit the comment/reply */
  readonly canEdit?: Maybe<Scalars['Boolean']>,
  /** can the user resolve the discussion */
  readonly canResolve?: Maybe<Scalars['Boolean']>,
  /** view the comment in more detail */
  readonly showUrl?: Maybe<Scalars['String']>,
};

/** The connection type for Comment. */
export type CommentConnection = {
  __typename: 'CommentConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CommentEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Comment>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
  readonly total: Scalars['Int'],
  readonly totalOpen: Scalars['Int'],
  readonly totalResolved: Scalars['Int'],
};

/** An edge in a connection. */
export type CommentEdge = {
  __typename: 'CommentEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<Comment>,
};

export type CommentMention = {
  __typename: 'CommentMention',
  /** mentioned user id */
  readonly id: Scalars['ID'],
  /** mentioned user name */
  readonly name: Scalars['String'],
  /** has the mentioned user replied to this comment */
  readonly replied: Scalars['Boolean'],
};

export enum CommentRestriction {
  All = 'ALL',
  Involved = 'INVOLVED'
}

export type CommentsFilter = {
  readonly restriction?: Maybe<CommentRestriction>,
  readonly scopeId: Scalars['ID'],
  readonly status?: Maybe<CommentStatus>,
};

export enum CommentSort {
  RecentlyActive = 'RECENTLY_ACTIVE',
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyResolved = 'RECENTLY_RESOLVED'
}

export enum CommentStatus {
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type CompleteConsensusFormInput = {
  readonly data: Scalars['JSON'],
  readonly sourceIds: ReadonlyArray<Scalars['ID']>,
  readonly unresolvedFields?: Maybe<ReadonlyArray<UnresolvedFields>>,
};

/** Autogenerated input type of CompleteConsensus */
export type CompleteConsensusInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly dataExtraction?: Maybe<CompleteConsensusFormInput>,
  readonly qualityAssessment?: Maybe<CompleteConsensusFormInput>,
  readonly studyId: Scalars['ID'],
};

/** Autogenerated return type of CompleteConsensus */
export type CompleteConsensusPayload = MutationResultInterface & {
  __typename: 'CompleteConsensusPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly dataExtractionConsensusRevision?: Maybe<ConsensusRevision>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly qualityAssessmentConsensusRevision?: Maybe<ConsensusRevision>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of CompleteExtractedData */
export type CompleteExtractedDataInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly dataExtraction?: Maybe<SaveFormExtractedDataInput>,
  readonly qualityAssessment?: Maybe<SaveFormExtractedDataInput>,
  readonly studyId: Scalars['ID'],
};

/** Autogenerated return type of CompleteExtractedData */
export type CompleteExtractedDataPayload = MutationResultInterface & {
  __typename: 'CompleteExtractedDataPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly dataExtractionRevision?: Maybe<ExtractedDataRevision>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly qualityAssessmentRevision?: Maybe<ExtractedDataRevision>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of CompleteExtractionForm */
export type CompleteExtractionFormInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly definition: Scalars['JSON'],
  readonly extractionFormId?: Maybe<Scalars['ID']>,
  readonly formType?: Maybe<Scalars['String']>,
  readonly reviewId?: Maybe<Scalars['ID']>,
  readonly reviewerId?: Maybe<Scalars['ID']>,
};

/** Autogenerated return type of CompleteExtractionForm */
export type CompleteExtractionFormPayload = MutationResultInterface & {
  __typename: 'CompleteExtractionFormPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly extractionFormRevision: ExtractionFormRevision,
  readonly success: Scalars['Boolean'],
};

export type Consensus = Node & {
  __typename: 'Consensus',
  readonly currentRevision: ConsensusRevision,
  readonly decider: User,
  readonly extractionForm: ExtractionForm,
  readonly id: Scalars['ID'],
  readonly review: Review,
  readonly revisions: ConsensusRevisionConnection,
  readonly study: Study,
};


export type ConsensusRevisionsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export type ConsensusReassignment = {
  readonly preserveData: Scalars['Boolean'],
  readonly reviewerId: Scalars['ID'],
};

export type ConsensusRevision = Node & {
  __typename: 'ConsensusRevision',
  readonly consensus: Consensus,
  readonly data: Scalars['JSON'],
  readonly id: Scalars['ID'],
  readonly sources: ReadonlyArray<ExtractedDataRevision>,
  readonly study: Study,
};

/** The connection type for ConsensusRevision. */
export type ConsensusRevisionConnection = {
  __typename: 'ConsensusRevisionConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ConsensusRevisionEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ConsensusRevision>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
};

/** An edge in a connection. */
export type ConsensusRevisionEdge = {
  __typename: 'ConsensusRevisionEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<ConsensusRevision>,
};

export type ConsensusSlot = {
  __typename: 'ConsensusSlot',
  readonly assigned: Scalars['Boolean'],
  readonly completed: Scalars['Boolean'],
  readonly currentUser: Scalars['Boolean'],
  readonly decider?: Maybe<ExtractionSlotUser>,
  readonly lastActivityAgo?: Maybe<Scalars['String']>,
  readonly started: Scalars['Boolean'],
};

/** Autogenerated input type of CreateComment */
export type CreateCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  /** the content of the comment */
  readonly content: Scalars['String'],
  /** the ids of the reviewers whose are mentioned in the comment */
  readonly mentionedReviewerIds: ReadonlyArray<Scalars['ID']>,
  /** the ids of the studies being commented on */
  readonly studyIds: ReadonlyArray<Scalars['ID']>,
};

/** Autogenerated return type of CreateComment */
export type CreateCommentPayload = MutationResultInterface & {
  __typename: 'CreateCommentPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of CreateExtractionForm */
export type CreateExtractionFormInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly definition: Scalars['JSON'],
  readonly name: Scalars['String'],
  readonly reviewId: Scalars['ID'],
  readonly type: ExtractionFormType,
};

/** Autogenerated return type of CreateExtractionForm */
export type CreateExtractionFormPayload = MutationResultInterface & {
  __typename: 'CreateExtractionFormPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly form?: Maybe<ExtractionForm>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of CreateExtractionFormRevision */
export type CreateExtractionFormRevisionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly definition: Scalars['JSON'],
  readonly extractionFormId?: Maybe<Scalars['ID']>,
  readonly formType?: Maybe<Scalars['String']>,
  readonly reviewId?: Maybe<Scalars['ID']>,
  readonly reviewerId?: Maybe<Scalars['ID']>,
};

/** Autogenerated return type of CreateExtractionFormRevision */
export type CreateExtractionFormRevisionPayload = MutationResultInterface & {
  __typename: 'CreateExtractionFormRevisionPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly extractionFormRevision: ExtractionFormRevision,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of CreateLinkedCochraneReview */
export type CreateLinkedCochraneReviewInput = {
  /** ID of the Account to which this review should be billed */
  readonly accountId: Scalars['ID'],
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  /** The ID of the Cochrane Review to which this new Covidence review should be linked */
  readonly cochraneReviewId: Scalars['ID'],
  /** Option to enable RCT Auto Exclusion */
  readonly enableRctAutoExclusion?: Maybe<Scalars['Boolean']>,
  /** Option to enable RCT classifier */
  readonly enableRctClassifier?: Maybe<Scalars['Boolean']>,
};

/** Autogenerated return type of CreateLinkedCochraneReview */
export type CreateLinkedCochraneReviewPayload = MutationResultInterface & {
  __typename: 'CreateLinkedCochraneReviewPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly review?: Maybe<Review>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of CreateReview */
export type CreateReviewInput = {
  /** ID of the Account to which this review should be billed */
  readonly accountId: Scalars['ID'],
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  /** Option to enable RCT Auto Exclusion if the area of research is medical and health sciences */
  readonly enableRctAutoExclusion?: Maybe<Scalars['Boolean']>,
  /** Option to enable RCT classifier if the area of research is medical and health sciences */
  readonly enableRctClassifier?: Maybe<Scalars['Boolean']>,
  /** Custom label if the type of question is other */
  readonly otherQuestionTypeLabel?: Maybe<Scalars['String']>,
  /** Custom label if the area of research is other */
  readonly otherResearchAreaLabel?: Maybe<Scalars['String']>,
  /** Custom label if the type of review is other */
  readonly otherReviewTypeLabel?: Maybe<Scalars['String']>,
  /** The type of question */
  readonly questionType: Scalars['String'],
  /** The area of research */
  readonly researchArea: Scalars['String'],
  /** The type of review */
  readonly reviewType: Scalars['String'],
  /** A unique title for this review */
  readonly title: Scalars['String'],
};

/** Autogenerated return type of CreateReview */
export type CreateReviewPayload = MutationResultInterface & {
  __typename: 'CreateReviewPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly review?: Maybe<Review>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of CreateTag */
export type CreateTagInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  /** A unique name within this review for the new Tag */
  readonly name: Scalars['String'],
  /** ID of a Review to create the tag under */
  readonly reviewId: Scalars['ID'],
};

/** Autogenerated return type of CreateTag */
export type CreateTagPayload = MutationResultInterface & {
  __typename: 'CreateTagPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
  /** The newly created Tag */
  readonly tag?: Maybe<Tag>,
};

/** Autogenerated input type of DeleteDocument */
export type DeleteDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly documentId: Scalars['ID'],
};

/** Autogenerated return type of DeleteDocument */
export type DeleteDocumentPayload = MutationResultInterface & {
  __typename: 'DeleteDocumentPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly documents: ReadonlyArray<Document>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of DeleteTag */
export type DeleteTagInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  /** ID of a Tag to delete */
  readonly id: Scalars['ID'],
};

/** Autogenerated return type of DeleteTag */
export type DeleteTagPayload = MutationResultInterface & {
  __typename: 'DeleteTagPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of DeleteTopicExpert */
export type DeleteTopicExpertInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  /** topic expert to delete */
  readonly id: Scalars['ID'],
};

/** Autogenerated return type of DeleteTopicExpert */
export type DeleteTopicExpertPayload = MutationResultInterface & {
  __typename: 'DeleteTopicExpertPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of DemoteOrganizationAdministratorToMember */
export type DemoteOrganizationAdministratorToMemberInput = {
  readonly administratorId: Scalars['ID'],
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly organizationId: Scalars['ID'],
};

/** Autogenerated return type of DemoteOrganizationAdministratorToMember */
export type DemoteOrganizationAdministratorToMemberPayload = MutationResultInterface & {
  __typename: 'DemoteOrganizationAdministratorToMemberPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly membership?: Maybe<Membership>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of DenyMailingListConsent */
export type DenyMailingListConsentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly signedSource: Scalars['String'],
};

/** Autogenerated return type of DenyMailingListConsent */
export type DenyMailingListConsentPayload = MutationResultInterface & {
  __typename: 'DenyMailingListConsentPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

export type DetailedStatistics = {
  __typename: 'DetailedStatistics',
  readonly available: Scalars['Int'],
  readonly complete: Scalars['Int'],
  readonly consensusRequired: Scalars['Int'],
  readonly contribution: Scalars['Int'],
  readonly notStarted: Scalars['Int'],
  readonly partiallyComplete: Scalars['Int'],
};

export type Document = Node & {
  __typename: 'Document',
  /** File name */
  readonly fileName?: Maybe<Scalars['String']>,
  readonly id: Scalars['ID'],
  readonly primaryDocument?: Maybe<Scalars['Boolean']>,
  readonly url: Scalars['String'],
};

export type DuplicateCluster = Node & {
  __typename: 'DuplicateCluster',
  /** The category in which the current master resides */
  readonly category: Category,
  readonly covidenceNumber: Scalars['Int'],
  readonly duplicates: ReadonlyArray<ReferenceInterface>,
  readonly id: Scalars['ID'],
  /** The base review phase the reference study was last in (T&A, Full Text, or Extraction */
  readonly lastReviewPhase: Scalars['String'],
  readonly master: ReferenceInterface,
};

/** An edge in a connection. */
export type DuplicateClusterEdge = {
  __typename: 'DuplicateClusterEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<DuplicateCluster>,
};

/** The connection type for DuplicateCluster. */
export type DuplicateConnection = {
  __typename: 'DuplicateConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<DuplicateClusterEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<DuplicateCluster>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
  /** The total number of system detected duplicates. */
  readonly systemDuplicates: Scalars['Int'],
  /** The total number of clusters of duplicates. Put another way, this is the number
   * of _original_ items with one or more associated duplicates.
 */
  readonly total: Scalars['Int'],
  /** The total number of duplicates. */
  readonly totalDuplicates: Scalars['Int'],
};

/** Autogenerated input type of EditComment */
export type EditCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  /** the updated content */
  readonly content: Scalars['String'],
  /** the id of the comment being edited */
  readonly existingCommentId: Scalars['ID'],
};

/** Autogenerated return type of EditComment */
export type EditCommentPayload = MutationResultInterface & {
  __typename: 'EditCommentPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of EditNote */
export type EditNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly noteContent: Scalars['String'],
  readonly noteId: Scalars['ID'],
};

/** Autogenerated return type of EditNote */
export type EditNotePayload = MutationResultInterface & {
  __typename: 'EditNotePayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};


export type Error = {
  __typename: 'Error',
  /** Unique error code */
  readonly code: Scalars['String'],
  /** Message describing error */
  readonly message: Scalars['String'],
};

/** Autogenerated input type of ExportOrganizationAuthorList */
export type ExportOrganizationAuthorListInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly filterAuthorsName?: Maybe<Scalars['String']>,
  readonly organizationId: Scalars['ID'],
  readonly sortDirection: SortDirection,
};

/** Autogenerated return type of ExportOrganizationAuthorList */
export type ExportOrganizationAuthorListPayload = MutationResultInterface & {
  __typename: 'ExportOrganizationAuthorListPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

export type ExtractedDataRevision = Node & {
  __typename: 'ExtractedDataRevision',
  readonly data: Scalars['JSON'],
  readonly formRevision: ExtractionFormRevision,
  readonly id: Scalars['ID'],
  readonly studyExtractor: StudyExtractor,
};

/** The connection type for ExtractedDataRevision. */
export type ExtractedDataRevisionConnection = {
  __typename: 'ExtractedDataRevisionConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ExtractedDataRevisionEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ExtractedDataRevision>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
};

/** An edge in a connection. */
export type ExtractedDataRevisionEdge = {
  __typename: 'ExtractedDataRevisionEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<ExtractedDataRevision>,
};

export type ExtractionForm = Node & {
  __typename: 'ExtractionForm',
  readonly creator: User,
  readonly currentRevision: ExtractionFormRevision,
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
  readonly review: Review,
  readonly revisions: ExtractionFormRevisionConnection,
  readonly type: ExtractionFormType,
};


export type ExtractionFormRevisionsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

/** The connection type for ExtractionForm. */
export type ExtractionFormConnection = {
  __typename: 'ExtractionFormConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ExtractionFormEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ExtractionForm>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
};

/** An edge in a connection. */
export type ExtractionFormEdge = {
  __typename: 'ExtractionFormEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<ExtractionForm>,
};

export type ExtractionFormRevision = Node & {
  __typename: 'ExtractionFormRevision',
  readonly creator: User,
  readonly definition: Scalars['JSON'],
  readonly form: ExtractionForm,
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
};

/** The connection type for ExtractionFormRevision. */
export type ExtractionFormRevisionConnection = {
  __typename: 'ExtractionFormRevisionConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ExtractionFormRevisionEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ExtractionFormRevision>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
};

/** An edge in a connection. */
export type ExtractionFormRevisionEdge = {
  __typename: 'ExtractionFormRevisionEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<ExtractionFormRevision>,
};

export enum ExtractionFormType {
  DataExtraction = 'DATA_EXTRACTION',
  QualityAssessment = 'QUALITY_ASSESSMENT'
}

export type ExtractionProgress = {
  __typename: 'ExtractionProgress',
  readonly consensusSlot?: Maybe<ConsensusSlot>,
  readonly extractionSlots: ReadonlyArray<ExtractionSlot>,
  readonly status: ExtractionProgressStatus,
};

export enum ExtractionProgressStatus {
  AwaitingTemplatePublication = 'AWAITING_TEMPLATE_PUBLICATION',
  Complete = 'COMPLETE',
  Consensus = 'CONSENSUS',
  Extraction = 'EXTRACTION',
  NotStarted = 'NOT_STARTED'
}

export type ExtractionReassignment = {
  readonly currentReviewerId: Scalars['ID'],
  readonly newReviewerId: Scalars['ID'],
  readonly preserveData: Scalars['Boolean'],
};

export type ExtractionSlot = {
  __typename: 'ExtractionSlot',
  readonly assigned: Scalars['Boolean'],
  readonly completed: Scalars['Boolean'],
  readonly currentUser: Scalars['Boolean'],
  readonly extractor?: Maybe<ExtractionSlotUser>,
  readonly lastActivityAgo?: Maybe<Scalars['String']>,
};

export type ExtractionSlotUser = {
  __typename: 'ExtractionSlotUser',
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
};

export type ExtractionStudiesFilter = {
  readonly status?: Maybe<ExtractionStudiesStatus>,
};

export enum ExtractionStudiesStatus {
  /** Complete */
  Complete = 'COMPLETE',
  /** Consensus required */
  ConsensusRequired = 'CONSENSUS_REQUIRED',
  /** In progress */
  InProgress = 'IN_PROGRESS',
  /** Not started */
  NotStarted = 'NOT_STARTED'
}

export type ExtractionStudy = Node & {
  __typename: 'ExtractionStudy',
  readonly actions: StudyActions,
  readonly authors?: Maybe<Scalars['String']>,
  readonly covidenceNumber: Scalars['Int'],
  readonly id: Scalars['ID'],
  readonly notes: ReadonlyArray<Note>,
  readonly pdfUrl?: Maybe<Scalars['String']>,
  readonly progress: ExtractionProgress,
  readonly references: ReportConnection,
  readonly studyId?: Maybe<Scalars['String']>,
  readonly tags: ReadonlyArray<Scalars['String']>,
  readonly title?: Maybe<Scalars['String']>,
};


export type ExtractionStudyReferencesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

/** The connection type for ExtractionStudy. */
export type ExtractionStudyConnection = {
  __typename: 'ExtractionStudyConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ExtractionStudyEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ExtractionStudy>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
  readonly total: Scalars['Int'],
};

/** An edge in a connection. */
export type ExtractionStudyEdge = {
  __typename: 'ExtractionStudyEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<ExtractionStudy>,
};

export enum ExtractionStudySort {
  Author = 'author',
  CovidenceNumber = 'covidence_number',
  MostRecent = 'most_recent',
  MostRelevantAi = 'most_relevant_ai',
  Relevancy = 'relevancy',
  Title = 'title'
}

/** Autogenerated input type of GenerateSignedUploadUrl */
export type GenerateSignedUploadUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly filename: Scalars['String'],
  readonly referenceId: Scalars['ID'],
};

/** Autogenerated return type of GenerateSignedUploadUrl */
export type GenerateSignedUploadUrlPayload = MutationResultInterface & {
  __typename: 'GenerateSignedUploadUrlPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
  readonly url?: Maybe<Scalars['String']>,
};

/** Autogenerated input type of GrantMailingListConsent */
export type GrantMailingListConsentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly signedSource: Scalars['String'],
};

/** Autogenerated return type of GrantMailingListConsent */
export type GrantMailingListConsentPayload = MutationResultInterface & {
  __typename: 'GrantMailingListConsentPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

export type Guideline = Node & {
  __typename: 'Guideline',
  readonly actions: GuidelineActions,
  readonly createdAgo: Scalars['String'],
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
  readonly topicExpertInvites?: Maybe<TopicExpertInviteConnection>,
  readonly topicExperts?: Maybe<TopicExpertConnection>,
  readonly topics?: Maybe<TopicConnection>,
};


export type GuidelineTopicExpertInvitesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type GuidelineTopicExpertsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type GuidelineTopicsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

/** URLs for user actions that can be taken on this guideline and urls for some. */
export type GuidelineActions = {
  __typename: 'GuidelineActions',
  /** can the user invite topic experts */
  readonly canInviteTopicExpert: Scalars['Boolean'],
  /** form to invite topic experts */
  readonly inviteTopicExpertUrl: Scalars['String'],
};

/** The connection type for Guideline. */
export type GuidelineConnection = {
  __typename: 'GuidelineConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<GuidelineEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Guideline>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
};

/** An edge in a connection. */
export type GuidelineEdge = {
  __typename: 'GuidelineEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<Guideline>,
};

export type HasDuplicatesInterface = {
  readonly duplicates: DuplicateConnection,
};


export type HasDuplicatesInterfaceDuplicatesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export type Import = HasDuplicatesInterface & Node & {
  __typename: 'Import',
  readonly createdAt: Scalars['Time'],
  /** Default category into which imported studies will go */
  readonly defaultCategory: Category,
  readonly detectedCitationsCount: Scalars['Int'],
  readonly duplicateCitationsCount: Scalars['Int'],
  readonly duplicates: DuplicateConnection,
  readonly error?: Maybe<Error>,
  readonly id: Scalars['ID'],
  readonly importedStudiesCount: Scalars['Int'],
  readonly isFinished: Scalars['Boolean'],
  readonly source: ImportSource,
  readonly state: ImportState,
};


export type ImportDuplicatesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

/** The connection type for Import. */
export type ImportConnection = {
  __typename: 'ImportConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ImportEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Import>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
};

/** An edge in a connection. */
export type ImportEdge = {
  __typename: 'ImportEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<Import>,
};

export enum ImportSource {
  Crs = 'CRS',
  File = 'FILE',
  GuidelineTriage = 'GUIDELINE_TRIAGE',
  StudyTriage = 'STUDY_TRIAGE'
}

export enum ImportState {
  Failed = 'FAILED',
  Finalized = 'FINALIZED',
  Finalizing = 'FINALIZING',
  Imported = 'IMPORTED',
  Importing = 'IMPORTING',
  New = 'NEW',
  Prepared = 'PREPARED',
  Preparing = 'PREPARING',
  Sourced = 'SOURCED',
  Sourcing = 'SOURCING',
  Undoing = 'UNDOING',
  Undone = 'UNDONE',
  UndoFailed = 'UNDO_FAILED'
}

/** Autogenerated input type of InitiateCRSImport */
export type InitiateCrsImportInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly cochraneReviewLinkId: Scalars['ID'],
};

/** Autogenerated return type of InitiateCRSImport */
export type InitiateCrsImportPayload = MutationResultInterface & {
  __typename: 'InitiateCRSImportPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

export type Invitation = Node & {
  __typename: 'Invitation',
  readonly email: Scalars['Email'],
  readonly expiresAt: Scalars['Time'],
  readonly id: Scalars['ID'],
  readonly name?: Maybe<Scalars['String']>,
};

/** The connection type for Invitation. */
export type InvitationConnection = {
  __typename: 'InvitationConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<InvitationEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Invitation>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
};

/** An edge in a connection. */
export type InvitationEdge = {
  __typename: 'InvitationEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<Invitation>,
};

export type Invite = Node & {
  __typename: 'Invite',
  readonly accepted: Scalars['Boolean'],
  readonly acceptedAt?: Maybe<Scalars['Time']>,
  readonly createdAt: Scalars['Time'],
  readonly declined: Scalars['Boolean'],
  readonly declinedAt?: Maybe<Scalars['Time']>,
  readonly email: Scalars['String'],
  readonly expired: Scalars['Boolean'],
  readonly expiresAt: Scalars['Time'],
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
  readonly pending: Scalars['Boolean'],
  readonly sentAt?: Maybe<Scalars['Time']>,
};

/** The connection type for Invite. */
export type InviteConnection = {
  __typename: 'InviteConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<InviteEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Invite>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
  readonly total: Scalars['Int'],
};

/** An edge in a connection. */
export type InviteEdge = {
  __typename: 'InviteEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<Invite>,
};

/** Autogenerated input type of InvitePersonToOrganization */
export type InvitePersonToOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly email: Scalars['Email'],
  readonly name: Scalars['String'],
  readonly organizationId: Scalars['ID'],
  readonly resend: Scalars['Boolean'],
};

/** Autogenerated return type of InvitePersonToOrganization */
export type InvitePersonToOrganizationPayload = MutationResultInterface & {
  __typename: 'InvitePersonToOrganizationPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly invitation?: Maybe<Invitation>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of InviteTopicExpert */
export type InviteTopicExpertInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  /** the email of invitee */
  readonly email: Scalars['String'],
  /** the guideline to invite to */
  readonly guidelineId: Scalars['ID'],
  /** the name of invitee */
  readonly name: Scalars['String'],
  /** the ids of the topics they will be assigned to */
  readonly topicIds: ReadonlyArray<Scalars['ID']>,
};

/** Autogenerated return type of InviteTopicExpert */
export type InviteTopicExpertPayload = MutationResultInterface & {
  __typename: 'InviteTopicExpertPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};


export enum LinkStatus {
  All = 'ALL',
  Linked = 'LINKED',
  Unlinked = 'UNLINKED'
}

/** Autogenerated input type of MarkAsNotDuplicate */
export type MarkAsNotDuplicateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  /** ID of a record which is considered a duplicate and conforms to the ReferenceInterface */
  readonly id: Scalars['ID'],
};

/** Autogenerated return type of MarkAsNotDuplicate */
export type MarkAsNotDuplicatePayload = MutationResultInterface & {
  __typename: 'MarkAsNotDuplicatePayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly originalCluster?: Maybe<DuplicateCluster>,
  readonly reference: ReferenceInterface,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of MarkDocumentAsPrimary */
export type MarkDocumentAsPrimaryInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly documentId: Scalars['ID'],
};

/** Autogenerated return type of MarkDocumentAsPrimary */
export type MarkDocumentAsPrimaryPayload = MutationResultInterface & {
  __typename: 'MarkDocumentAsPrimaryPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly documents: ReadonlyArray<Document>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

export type Membership = Node & {
  __typename: 'Membership',
  readonly assignedReviews: ReviewConnection,
  readonly id: Scalars['ID'],
  readonly invitation?: Maybe<Invitation>,
  readonly member: User,
  readonly memberSince?: Maybe<Scalars['Time']>,
  readonly organization: Organization,
  readonly organizationReviews?: Maybe<ReviewConnection>,
  readonly status: MembershipStatus,
};


export type MembershipAssignedReviewsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type MembershipOrganizationReviewsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

/** The connection type for Membership. */
export type MembershipConnection = {
  __typename: 'MembershipConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<MembershipEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Membership>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
};

/** An edge in a connection. */
export type MembershipEdge = {
  __typename: 'MembershipEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<Membership>,
};

export enum MembershipStatus {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  NotAMember = 'NOT_A_MEMBER'
}

/** Autogenerated input type of MergeStudies */
export type MergeStudiesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly desiredMasterStudyId: Scalars['ID'],
  readonly studyIds: ReadonlyArray<Scalars['ID']>,
};

/** Autogenerated return type of MergeStudies */
export type MergeStudiesPayload = MutationResultInterface & {
  __typename: 'MergeStudiesPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly studies?: Maybe<ReadonlyArray<Study>>,
  readonly success: Scalars['Boolean'],
};

export type Mutation = {
  __typename: 'Mutation',
  readonly addNoteToStudy?: Maybe<AddNoteToStudyPayload>,
  readonly addReplyToComment?: Maybe<AddReplyToCommentPayload>,
  readonly addTagsToStudies?: Maybe<AddTagsToStudiesPayload>,
  readonly addUploadedDocument?: Maybe<AddUploadedDocumentPayload>,
  /** (Re-)assign an administrator to a review owned by the specified organization */
  readonly assignOrganizationAdministratorToReview?: Maybe<AssignOrganizationAdministratorToReviewPayload>,
  readonly cancelInvitation?: Maybe<CancelInvitationPayload>,
  readonly cancelTopicExpertInvite?: Maybe<CancelTopicExpertInvitePayload>,
  readonly changeStudyIdentifier?: Maybe<ChangeStudyIdentifierPayload>,
  readonly completeConsensus?: Maybe<CompleteConsensusPayload>,
  readonly completeExtractedData?: Maybe<CompleteExtractedDataPayload>,
  readonly completeExtractionForm?: Maybe<CompleteExtractionFormPayload>,
  readonly createComment?: Maybe<CreateCommentPayload>,
  readonly createExtractionForm?: Maybe<CreateExtractionFormPayload>,
  readonly createExtractionFormRevision?: Maybe<CreateExtractionFormRevisionPayload>,
  readonly createLinkedCochraneReview?: Maybe<CreateLinkedCochraneReviewPayload>,
  readonly createReview?: Maybe<CreateReviewPayload>,
  readonly createTag?: Maybe<CreateTagPayload>,
  readonly deleteDocument?: Maybe<DeleteDocumentPayload>,
  readonly deleteTag?: Maybe<DeleteTagPayload>,
  readonly deleteTopicExpert?: Maybe<DeleteTopicExpertPayload>,
  readonly demoteOrganizationAdministratorToMember?: Maybe<DemoteOrganizationAdministratorToMemberPayload>,
  readonly denyMailingListConsent?: Maybe<DenyMailingListConsentPayload>,
  readonly editComment?: Maybe<EditCommentPayload>,
  readonly editNote?: Maybe<EditNotePayload>,
  readonly exportOrganizationAuthorList?: Maybe<ExportOrganizationAuthorListPayload>,
  readonly generateSignedUploadUrl?: Maybe<GenerateSignedUploadUrlPayload>,
  readonly grantMailingListConsent?: Maybe<GrantMailingListConsentPayload>,
  readonly initiateCrsImport?: Maybe<InitiateCrsImportPayload>,
  readonly invitePersonToOrganization?: Maybe<InvitePersonToOrganizationPayload>,
  readonly inviteTopicExpert?: Maybe<InviteTopicExpertPayload>,
  readonly markAsNotDuplicate?: Maybe<MarkAsNotDuplicatePayload>,
  readonly markDocumentAsPrimary?: Maybe<MarkDocumentAsPrimaryPayload>,
  readonly mergeStudies?: Maybe<MergeStudiesPayload>,
  readonly promoteOrganizationMemberToAdministrator?: Maybe<PromoteOrganizationMemberToAdministratorPayload>,
  readonly reassignStudyReviewer?: Maybe<ReassignStudyReviewerPayload>,
  readonly recordStudyVote?: Maybe<RecordStudyVotePayload>,
  readonly removeNote?: Maybe<RemoveNotePayload>,
  readonly removeReviewer?: Maybe<RemoveReviewerPayload>,
  readonly removeTagsFromStudies?: Maybe<RemoveTagsFromStudiesPayload>,
  readonly resendTopicExpertInvite?: Maybe<ResendTopicExpertInvitePayload>,
  readonly resolveDiscussion?: Maybe<ResolveDiscussionPayload>,
  readonly revertTemplate?: Maybe<RevertTemplatePayload>,
  readonly revokeMembership?: Maybe<RevokeMembershipPayload>,
  readonly saveConsensus?: Maybe<SaveConsensusPayload>,
  readonly saveExtractedData?: Maybe<SaveExtractedDataPayload>,
  /** Remove any administrator assignment for an organizational review */
  readonly unassignOrganizationAdministratorFromReview?: Maybe<UnassignOrganizationAdministratorFromReviewPayload>,
  readonly unmergeStudies?: Maybe<UnmergeStudiesPayload>,
};


export type MutationAddNoteToStudyArgs = {
  input: AddNoteToStudyInput
};


export type MutationAddReplyToCommentArgs = {
  input: AddReplyToCommentInput
};


export type MutationAddTagsToStudiesArgs = {
  input: AddTagsToStudiesInput
};


export type MutationAddUploadedDocumentArgs = {
  input: AddUploadedDocumentInput
};


export type MutationAssignOrganizationAdministratorToReviewArgs = {
  input: AssignOrganizationAdministratorToReviewInput
};


export type MutationCancelInvitationArgs = {
  input: CancelInvitationInput
};


export type MutationCancelTopicExpertInviteArgs = {
  input: CancelTopicExpertInviteInput
};


export type MutationChangeStudyIdentifierArgs = {
  input: ChangeStudyIdentifierInput
};


export type MutationCompleteConsensusArgs = {
  input: CompleteConsensusInput
};


export type MutationCompleteExtractedDataArgs = {
  input: CompleteExtractedDataInput
};


export type MutationCompleteExtractionFormArgs = {
  input: CompleteExtractionFormInput
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput
};


export type MutationCreateExtractionFormArgs = {
  input: CreateExtractionFormInput
};


export type MutationCreateExtractionFormRevisionArgs = {
  input: CreateExtractionFormRevisionInput
};


export type MutationCreateLinkedCochraneReviewArgs = {
  input: CreateLinkedCochraneReviewInput
};


export type MutationCreateReviewArgs = {
  input: CreateReviewInput
};


export type MutationCreateTagArgs = {
  input: CreateTagInput
};


export type MutationDeleteDocumentArgs = {
  input: DeleteDocumentInput
};


export type MutationDeleteTagArgs = {
  input: DeleteTagInput
};


export type MutationDeleteTopicExpertArgs = {
  input: DeleteTopicExpertInput
};


export type MutationDemoteOrganizationAdministratorToMemberArgs = {
  input: DemoteOrganizationAdministratorToMemberInput
};


export type MutationDenyMailingListConsentArgs = {
  input: DenyMailingListConsentInput
};


export type MutationEditCommentArgs = {
  input: EditCommentInput
};


export type MutationEditNoteArgs = {
  input: EditNoteInput
};


export type MutationExportOrganizationAuthorListArgs = {
  input: ExportOrganizationAuthorListInput
};


export type MutationGenerateSignedUploadUrlArgs = {
  input: GenerateSignedUploadUrlInput
};


export type MutationGrantMailingListConsentArgs = {
  input: GrantMailingListConsentInput
};


export type MutationInitiateCrsImportArgs = {
  input: InitiateCrsImportInput
};


export type MutationInvitePersonToOrganizationArgs = {
  input: InvitePersonToOrganizationInput
};


export type MutationInviteTopicExpertArgs = {
  input: InviteTopicExpertInput
};


export type MutationMarkAsNotDuplicateArgs = {
  input: MarkAsNotDuplicateInput
};


export type MutationMarkDocumentAsPrimaryArgs = {
  input: MarkDocumentAsPrimaryInput
};


export type MutationMergeStudiesArgs = {
  input: MergeStudiesInput
};


export type MutationPromoteOrganizationMemberToAdministratorArgs = {
  input: PromoteOrganizationMemberToAdministratorInput
};


export type MutationReassignStudyReviewerArgs = {
  input: ReassignStudyReviewerInput
};


export type MutationRecordStudyVoteArgs = {
  input: RecordStudyVoteInput
};


export type MutationRemoveNoteArgs = {
  input: RemoveNoteInput
};


export type MutationRemoveReviewerArgs = {
  input: RemoveReviewerInput
};


export type MutationRemoveTagsFromStudiesArgs = {
  input: RemoveTagsFromStudiesInput
};


export type MutationResendTopicExpertInviteArgs = {
  input: ResendTopicExpertInviteInput
};


export type MutationResolveDiscussionArgs = {
  input: ResolveDiscussionInput
};


export type MutationRevertTemplateArgs = {
  input: RevertTemplateInput
};


export type MutationRevokeMembershipArgs = {
  input: RevokeMembershipInput
};


export type MutationSaveConsensusArgs = {
  input: SaveConsensusInput
};


export type MutationSaveExtractedDataArgs = {
  input: SaveExtractedDataInput
};


export type MutationUnassignOrganizationAdministratorFromReviewArgs = {
  input: UnassignOrganizationAdministratorFromReviewInput
};


export type MutationUnmergeStudiesArgs = {
  input: UnmergeStudiesInput
};

export type MutationResultInterface = {
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  readonly id: Scalars['ID'],
};

export type Note = Node & {
  __typename: 'Note',
  readonly author: NoteAuthor,
  readonly createdAt: Scalars['String'],
  readonly id: Scalars['ID'],
  readonly note: Scalars['String'],
  readonly updatedAt: Scalars['String'],
};

export type NoteAuthor = Node & {
  __typename: 'NoteAuthor',
  readonly dbId: Scalars['ID'],
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
  readonly primaryEmail: Scalars['Email'],
};

export type Organization = Node & {
  __typename: 'Organization',
  readonly account: Account,
  readonly administrators: UserConnection,
  readonly authors: UserConnection,
  readonly exports?: Maybe<ReadonlyArray<AuthorExport>>,
  readonly id: Scalars['ID'],
  readonly invitations: InvitationConnection,
  readonly memberships: MembershipConnection,
  readonly name: Scalars['String'],
  readonly reviews: ReviewConnection,
};


export type OrganizationAdministratorsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  sort?: Maybe<UserSort>,
  sortDirection?: Maybe<SortDirection>
};


export type OrganizationAuthorsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  filter?: Maybe<OrganizationAuthorsFilter>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  sort?: Maybe<UserSort>,
  sortDirection?: Maybe<SortDirection>
};


export type OrganizationInvitationsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  filter?: Maybe<OrganizationInvitationsFilter>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type OrganizationMembershipsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  filter?: Maybe<OrganizationMembershipsFilter>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type OrganizationReviewsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  filter?: Maybe<OrganizationReviewsFilter>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  sort?: Maybe<ReviewSort>,
  sortDirection?: Maybe<SortDirection>
};

export type OrganizationAuthorsFilter = {
  readonly search?: Maybe<Scalars['String']>,
};

export type OrganizationInvitationsFilter = {
  readonly email?: Maybe<Scalars['String']>,
};

export type OrganizationMembershipsFilter = {
  readonly search?: Maybe<Scalars['String']>,
};

export type OrganizationReviewsFilter = {
  readonly assignedAdministrator?: Maybe<Scalars['ID']>,
  readonly includeDeleted?: Maybe<Scalars['Boolean']>,
  readonly search?: Maybe<Scalars['String']>,
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename: 'PageInfo',
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']>,
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean'],
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean'],
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']>,
};

export type Plan = {
  __typename: 'Plan',
  readonly billingPeriodUnit: Scalars['String'],
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
  readonly numberOfReviewers?: Maybe<Scalars['Int']>,
  readonly numberOfReviews?: Maybe<Scalars['Int']>,
  readonly price: Price,
  readonly screenLimit?: Maybe<Scalars['Int']>,
};

export type Price = {
  __typename: 'Price',
  readonly amount: Scalars['Int'],
  readonly currency: Scalars['String'],
};

/** Autogenerated input type of PromoteOrganizationMemberToAdministrator */
export type PromoteOrganizationMemberToAdministratorInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly memberId: Scalars['ID'],
  readonly organizationId: Scalars['ID'],
};

/** Autogenerated return type of PromoteOrganizationMemberToAdministrator */
export type PromoteOrganizationMemberToAdministratorPayload = MutationResultInterface & {
  __typename: 'PromoteOrganizationMemberToAdministratorPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly membership?: Maybe<Membership>,
  readonly success: Scalars['Boolean'],
};

/** Details about the report publication. Most data in these fields is
 * unstructured (i.e. as it appears in source material) and therefore
 * typed as Strings even where another type might be appropriate.
 */
export type Publication = {
  __typename: 'Publication',
  /** The journal issue in which the report appeared */
  readonly issue?: Maybe<Scalars['String']>,
  /** The journal name in which the report appeared */
  readonly journal?: Maybe<Scalars['String']>,
  /** The location in which the report was published */
  readonly location?: Maybe<Scalars['String']>,
  /** The month in which the report was published */
  readonly month?: Maybe<Scalars['String']>,
  /** The page or pages in which the report appeared in the issue */
  readonly pages?: Maybe<Scalars['String']>,
  /** The publisher of the report or its journal */
  readonly publisher?: Maybe<Scalars['String']>,
  /** The journal volume in which the report appeared */
  readonly volume?: Maybe<Scalars['String']>,
  /** The year in which the report was published */
  readonly year?: Maybe<Scalars['String']>,
};

export type Query = {
  __typename: 'Query',
  /** Cochrane-specific data */
  readonly cochrane: Cochrane,
  readonly comments?: Maybe<CommentConnection>,
  readonly guidelines?: Maybe<GuidelineConnection>,
  /** The currently authenticated user */
  readonly me?: Maybe<User>,
  /** Fetches an object given its ID. */
  readonly node?: Maybe<Node>,
  readonly ping: Scalars['String'],
  readonly reviews: ReviewConnection,
};


export type QueryCommentsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  filter: CommentsFilter,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  sort?: Maybe<CommentSort>,
  sortDirection?: Maybe<SortDirection>
};


export type QueryGuidelinesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryNodeArgs = {
  id: Scalars['ID']
};


export type QueryReviewsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

/** Autogenerated input type of ReassignStudyReviewer */
export type ReassignStudyReviewerInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly consensusReassignment?: Maybe<ConsensusReassignment>,
  readonly extractorReassignments?: Maybe<ReadonlyArray<Maybe<ExtractionReassignment>>>,
  readonly studyId: Scalars['ID'],
};

/** Autogenerated return type of ReassignStudyReviewer */
export type ReassignStudyReviewerPayload = MutationResultInterface & {
  __typename: 'ReassignStudyReviewerPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly progress: ExtractionProgress,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of RecordStudyVote */
export type RecordStudyVoteInput = {
  readonly category?: Maybe<Category>,
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly exclusionReason?: Maybe<Scalars['String']>,
  readonly studyId: Scalars['ID'],
  readonly vote: VoteValue,
};

/** Autogenerated return type of RecordStudyVote */
export type RecordStudyVotePayload = MutationResultInterface & {
  __typename: 'RecordStudyVotePayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** An interface for any type which has citation data. Most fields are nullable
 * because data quality is inconsistent and many fields can be missing.
 */
export type ReferenceInterface = {
  /** The abstract of the report */
  readonly abstract?: Maybe<Scalars['String']>,
  /** List of authors for the report */
  readonly authors: Scalars['String'],
  /** Digital Object Identifier */
  readonly doi?: Maybe<Scalars['String']>,
  readonly id?: Maybe<Scalars['ID']>,
  readonly primaryAuthor: Scalars['String'],
  /** Details about the report publication. Most data in these fields is
   * unstructured (i.e. as it appears in source material) and therefore
   * typed as Strings even where another type might be appropriate.
 */
  readonly publication?: Maybe<Publication>,
  /** The title of the report */
  readonly title?: Maybe<Scalars['String']>,
};

/** Autogenerated input type of RemoveNote */
export type RemoveNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly noteId: Scalars['ID'],
};

/** Autogenerated return type of RemoveNote */
export type RemoveNotePayload = MutationResultInterface & {
  __typename: 'RemoveNotePayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of RemoveReviewer */
export type RemoveReviewerInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly reviewId: Scalars['ID'],
  readonly reviewerId: Scalars['ID'],
};

/** Autogenerated return type of RemoveReviewer */
export type RemoveReviewerPayload = MutationResultInterface & {
  __typename: 'RemoveReviewerPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of RemoveTagsFromStudies */
export type RemoveTagsFromStudiesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly studyIds: ReadonlyArray<Scalars['ID']>,
  readonly tags: ReadonlyArray<Scalars['String']>,
};

/** Autogenerated return type of RemoveTagsFromStudies */
export type RemoveTagsFromStudiesPayload = MutationResultInterface & {
  __typename: 'RemoveTagsFromStudiesPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

export type Report = Node & ReferenceInterface & {
  __typename: 'Report',
  /** The abstract of the report */
  readonly abstract?: Maybe<Scalars['String']>,
  readonly authors: Scalars['String'],
  readonly documents?: Maybe<ReadonlyArray<Document>>,
  /** Digital Object Identifier */
  readonly doi?: Maybe<Scalars['String']>,
  readonly fullText: Scalars['Boolean'],
  readonly id: Scalars['ID'],
  readonly journalInfo?: Maybe<Scalars['String']>,
  readonly primaryAuthor: Scalars['String'],
  /** Details about the report publication. Most data in these fields is
   * unstructured (i.e. as it appears in source material) and therefore
   * typed as Strings even where another type might be appropriate.
 */
  readonly publication?: Maybe<Publication>,
  readonly publisherInfo?: Maybe<Scalars['String']>,
  readonly referenceUrl?: Maybe<Scalars['String']>,
  readonly source?: Maybe<Scalars['String']>,
  readonly title?: Maybe<Scalars['String']>,
};

/** The connection type for Report. */
export type ReportConnection = {
  __typename: 'ReportConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ReportEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Report>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
  readonly total: Scalars['Int'],
};

/** An edge in a connection. */
export type ReportEdge = {
  __typename: 'ReportEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<Report>,
};

/** Autogenerated input type of ResendTopicExpertInvite */
export type ResendTopicExpertInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  /** id of the invite */
  readonly id: Scalars['ID'],
};

/** Autogenerated return type of ResendTopicExpertInvite */
export type ResendTopicExpertInvitePayload = MutationResultInterface & {
  __typename: 'ResendTopicExpertInvitePayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of ResolveDiscussion */
export type ResolveDiscussionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  /** the id of the comment being resolved */
  readonly commentId: Scalars['ID'],
};

/** Autogenerated return type of ResolveDiscussion */
export type ResolveDiscussionPayload = MutationResultInterface & {
  __typename: 'ResolveDiscussionPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of RevertTemplate */
export type RevertTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly templateId: Scalars['ID'],
};

/** Autogenerated return type of RevertTemplate */
export type RevertTemplatePayload = MutationResultInterface & {
  __typename: 'RevertTemplatePayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

export type Review = HasDuplicatesInterface & Node & {
  __typename: 'Review',
  readonly assignedAdministrator?: Maybe<User>,
  readonly categoryCounts: CategoryCounts,
  readonly cochraneReviewLink?: Maybe<CochraneReviewLink>,
  readonly collaborators: UserConnection,
  readonly createdAt: Scalars['Time'],
  readonly creator: User,
  readonly currentImport?: Maybe<Import>,
  readonly dbId: Scalars['ID'],
  readonly deletedAt?: Maybe<Scalars['Time']>,
  readonly duplicates: DuplicateConnection,
  readonly enabledFeatures: ReadonlyArray<Scalars['String']>,
  readonly excludedKeywords: ReadonlyArray<Scalars['String']>,
  readonly extractionForms: ExtractionFormConnection,
  readonly extractionStudies: ExtractionStudyConnection,
  readonly id: Scalars['ID'],
  readonly imports: ImportConnection,
  readonly includedKeywords: ReadonlyArray<Scalars['String']>,
  readonly invites: InviteConnection,
  readonly lastActivityAt: Scalars['Time'],
  readonly memberships: ReviewMembershipConnection,
  readonly owner: AccountOwner,
  readonly statistics: Statistics,
  readonly studies: StudyConnection,
  readonly studiesAvailableForVoting: ReadonlyArray<Study>,
  readonly tags: ReadonlyArray<Tag>,
  readonly title: Scalars['String'],
};


export type ReviewCollaboratorsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type ReviewDuplicatesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type ReviewExtractionFormsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type ReviewExtractionStudiesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  filter?: Maybe<ExtractionStudiesFilter>,
  filterByTags?: Maybe<ReadonlyArray<Scalars['String']>>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  sort?: Maybe<ExtractionStudySort>,
  sortDirection?: Maybe<SortDirection>,
  studyId?: Maybe<Scalars['ID']>
};


export type ReviewImportsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  finalized?: Maybe<Scalars['Boolean']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type ReviewInvitesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type ReviewMembershipsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type ReviewStudiesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  filter?: Maybe<StudiesFilter>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  sort?: Maybe<StudySort>,
  sortDirection?: Maybe<SortDirection>
};


export type ReviewStudiesAvailableForVotingArgs = {
  category: Category,
  excluding?: Maybe<ReadonlyArray<Scalars['ID']>>,
  reviewer: Scalars['ID']
};

/** The connection type for Review. */
export type ReviewConnection = {
  __typename: 'ReviewConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ReviewEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Review>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
  readonly total: Scalars['Int'],
};

/** An edge in a connection. */
export type ReviewEdge = {
  __typename: 'ReviewEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<Review>,
};

export type ReviewMembership = HasDuplicatesInterface & Node & {
  __typename: 'ReviewMembership',
  readonly acceptedAt?: Maybe<Scalars['Time']>,
  readonly createdAt: Scalars['Time'],
  readonly duplicates: DuplicateConnection,
  /** ID of the object. */
  readonly id: Scalars['ID'],
  readonly owner?: Maybe<Scalars['Boolean']>,
  readonly reviewer: User,
};


export type ReviewMembershipDuplicatesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

/** The connection type for ReviewMembership. */
export type ReviewMembershipConnection = {
  __typename: 'ReviewMembershipConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ReviewMembershipEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ReviewMembership>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
  readonly total: Scalars['Int'],
};

/** An edge in a connection. */
export type ReviewMembershipEdge = {
  __typename: 'ReviewMembershipEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<ReviewMembership>,
};

export enum ReviewSort {
  CreatedAt = 'CREATED_AT',
  LastActivityAt = 'LAST_ACTIVITY_AT',
  Title = 'TITLE'
}

/** Autogenerated input type of RevokeMembership */
export type RevokeMembershipInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly memberId: Scalars['ID'],
  readonly organizationId: Scalars['ID'],
};

/** Autogenerated return type of RevokeMembership */
export type RevokeMembershipPayload = MutationResultInterface & {
  __typename: 'RevokeMembershipPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly membership: Membership,
  readonly success: Scalars['Boolean'],
};

export type SaveConsensusFormInput = {
  readonly data: Scalars['JSON'],
  readonly sourceIds: ReadonlyArray<Scalars['ID']>,
  readonly unresolvedFields?: Maybe<ReadonlyArray<UnresolvedFields>>,
};

/** Autogenerated input type of SaveConsensus */
export type SaveConsensusInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly dataExtraction?: Maybe<SaveConsensusFormInput>,
  readonly qualityAssessment?: Maybe<SaveConsensusFormInput>,
  readonly studyId: Scalars['ID'],
};

/** Autogenerated return type of SaveConsensus */
export type SaveConsensusPayload = MutationResultInterface & {
  __typename: 'SaveConsensusPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly dataExtractionConsensusRevision?: Maybe<ConsensusRevision>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly qualityAssessmentConsensusRevision?: Maybe<ConsensusRevision>,
  readonly success: Scalars['Boolean'],
};

/** Autogenerated input type of SaveExtractedData */
export type SaveExtractedDataInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly dataExtraction?: Maybe<SaveFormExtractedDataInput>,
  readonly qualityAssessment?: Maybe<SaveFormExtractedDataInput>,
  readonly studyId: Scalars['ID'],
};

/** Autogenerated return type of SaveExtractedData */
export type SaveExtractedDataPayload = MutationResultInterface & {
  __typename: 'SaveExtractedDataPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly dataExtractionRevision?: Maybe<ExtractedDataRevision>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly qualityAssessmentRevision?: Maybe<ExtractedDataRevision>,
  readonly success: Scalars['Boolean'],
};

export type SaveFormExtractedDataInput = {
  readonly data: Scalars['JSON'],
  readonly formRevisionId: Scalars['ID'],
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Statistics = {
  __typename: 'Statistics',
  readonly included: DetailedStatistics,
  readonly screen: DetailedStatistics,
  readonly select: DetailedStatistics,
};

export type StudiesFilter = {
  readonly author?: Maybe<Scalars['String']>,
  readonly awaitingClassification?: Maybe<Scalars['Boolean']>,
  readonly category?: Maybe<Category>,
  readonly covidenceNumber?: Maybe<Scalars['Int']>,
  readonly ongoingStudy?: Maybe<Scalars['Boolean']>,
  readonly title?: Maybe<Scalars['String']>,
  readonly voteRequiredFrom?: Maybe<Scalars['Boolean']>,
};

export type Study = Node & {
  __typename: 'Study',
  readonly authors?: Maybe<Scalars['String']>,
  readonly awaitingClassification: Scalars['Boolean'],
  readonly covidenceNumber: Scalars['Int'],
  readonly id: Scalars['ID'],
  readonly notes: ReadonlyArray<Note>,
  readonly ongoingStudy: Scalars['Boolean'],
  readonly pdfUrl?: Maybe<Scalars['String']>,
  readonly references: ReportConnection,
  readonly studyId?: Maybe<Scalars['String']>,
  readonly tags: ReadonlyArray<Scalars['String']>,
  readonly title: Scalars['String'],
  readonly votes: VoteConnection,
};


export type StudyReferencesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type StudyVotesArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

/** URLs for user actions that can be taken on this study and urls for some. */
export type StudyActions = {
  __typename: 'StudyActions',
  /** view/create/continue study consensus for this study */
  readonly compareUrl?: Maybe<Scalars['String']>,
  /** edit study consensus for this study */
  readonly editCompareUrl?: Maybe<Scalars['String']>,
  /** view/edit study extraction for this study */
  readonly extractUrl?: Maybe<Scalars['String']>,
};

/** The connection type for Study. */
export type StudyConnection = {
  __typename: 'StudyConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<StudyEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Study>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
  readonly total: Scalars['Int'],
};

/** An edge in a connection. */
export type StudyEdge = {
  __typename: 'StudyEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<Study>,
};

export type StudyExtractor = Node & {
  __typename: 'StudyExtractor',
  readonly currentRevision: ExtractedDataRevision,
  readonly extractor: User,
  readonly form: ExtractionForm,
  readonly id: Scalars['ID'],
  readonly revisions: ExtractedDataRevisionConnection,
  readonly study: Study,
};


export type StudyExtractorRevisionsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export enum StudySort {
  Authors = 'AUTHORS',
  MostRecently = 'MOST_RECENTLY',
  MostRelevantAi = 'MOST_RELEVANT_AI',
  Relevancy = 'RELEVANCY',
  Title = 'TITLE'
}

export type Tag = Node & {
  __typename: 'Tag',
  readonly id: Scalars['ID'],
  readonly isDeleteable: Scalars['Boolean'],
  readonly name: Scalars['String'],
};


export type Topic = Node & {
  __typename: 'Topic',
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
};

/** The connection type for Topic. */
export type TopicConnection = {
  __typename: 'TopicConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<TopicEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Topic>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
};

/** An edge in a connection. */
export type TopicEdge = {
  __typename: 'TopicEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<Topic>,
};

export type TopicExpert = Node & {
  __typename: 'TopicExpert',
  readonly email: Scalars['String'],
  readonly expertTopics: ReadonlyArray<Topic>,
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
};

/** The connection type for TopicExpert. */
export type TopicExpertConnection = {
  __typename: 'TopicExpertConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<TopicExpertEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<TopicExpert>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
};

/** An edge in a connection. */
export type TopicExpertEdge = {
  __typename: 'TopicExpertEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<TopicExpert>,
};

export type TopicExpertInvite = Node & {
  __typename: 'TopicExpertInvite',
  readonly accepted: Scalars['Boolean'],
  readonly acceptedAt?: Maybe<Scalars['Time']>,
  readonly createdAt: Scalars['Time'],
  readonly declined: Scalars['Boolean'],
  readonly declinedAt?: Maybe<Scalars['Time']>,
  readonly email: Scalars['String'],
  readonly expertTopics: ReadonlyArray<Topic>,
  readonly expired: Scalars['Boolean'],
  readonly expiresAt: Scalars['Time'],
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
  readonly pending: Scalars['Boolean'],
};

/** The connection type for TopicExpertInvite. */
export type TopicExpertInviteConnection = {
  __typename: 'TopicExpertInviteConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<TopicExpertInviteEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<TopicExpertInvite>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
  readonly total: Scalars['Int'],
};

/** An edge in a connection. */
export type TopicExpertInviteEdge = {
  __typename: 'TopicExpertInviteEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<TopicExpertInvite>,
};

/** Autogenerated input type of UnassignOrganizationAdministratorFromReview */
export type UnassignOrganizationAdministratorFromReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly reviewId: Scalars['ID'],
};

/** Autogenerated return type of UnassignOrganizationAdministratorFromReview */
export type UnassignOrganizationAdministratorFromReviewPayload = MutationResultInterface & {
  __typename: 'UnassignOrganizationAdministratorFromReviewPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly review?: Maybe<Review>,
  readonly success: Scalars['Boolean'],
  /** Returns the administrator, if any, who was assigned to the review before
   * this action
 */
  readonly unassignedAdministrator?: Maybe<User>,
};

/** Autogenerated input type of UnmergeStudies */
export type UnmergeStudiesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly primaryStudyId: Scalars['ID'],
};

/** Autogenerated return type of UnmergeStudies */
export type UnmergeStudiesPayload = MutationResultInterface & {
  __typename: 'UnmergeStudiesPayload',
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']>,
  readonly errors?: Maybe<ReadonlyArray<Error>>,
  readonly success: Scalars['Boolean'],
};

export type UnresolvedFields = {
  readonly changedFields?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly reviewerId?: Maybe<Scalars['ID']>,
};

export type User = Node & {
  __typename: 'User',
  readonly account: Account,
  readonly billableAccounts: AccountConnection,
  readonly consent: UserConsent,
  readonly dbId: Scalars['ID'],
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
  readonly organization: Organization,
  readonly organizationMembership: Membership,
  readonly organizationMemberships: MembershipConnection,
  readonly primaryEmail: Scalars['Email'],
};


export type UserBillableAccountsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type UserConsentArgs = {
  name: Scalars['String']
};


export type UserOrganizationArgs = {
  id: Scalars['ID']
};


export type UserOrganizationMembershipArgs = {
  organization: Scalars['ID']
};


export type UserOrganizationMembershipsArgs = {
  after?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

/** The connection type for User. */
export type UserConnection = {
  __typename: 'UserConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<UserEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<User>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
  readonly total: Scalars['Int'],
};

export type UserConsent = {
  __typename: 'UserConsent',
  readonly decision: UserConsentDecision,
};

export enum UserConsentDecision {
  Consented = 'CONSENTED',
  Denied = 'DENIED',
  Outdated = 'OUTDATED',
  Unanswered = 'UNANSWERED'
}

/** An edge in a connection. */
export type UserEdge = {
  __typename: 'UserEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<User>,
};

export enum UserSort {
  Name = 'NAME'
}

export type Vote = Node & {
  __typename: 'Vote',
  readonly consensus: Scalars['Boolean'],
  readonly createdAt: Scalars['Time'],
  readonly id: Scalars['ID'],
  readonly reviewer: User,
  readonly studyCategory: Category,
  readonly vote: VoteValue,
};

/** The connection type for Vote. */
export type VoteConnection = {
  __typename: 'VoteConnection',
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<VoteEdge>>>,
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Vote>>>,
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo,
  readonly total: Scalars['Int'],
};

/** An edge in a connection. */
export type VoteEdge = {
  __typename: 'VoteEdge',
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'],
  /** The item at the end of the edge. */
  readonly node?: Maybe<Vote>,
};

export enum VoteValue {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE',
  Maybe = 'MAYBE',
  Merge = 'MERGE',
  No = 'NO',
  UndoCategory = 'UNDO_CATEGORY',
  UndoVote = 'UNDO_VOTE',
  Yes = 'YES'
}

export type ReviewTagsQueryVariables = {
  reviewId: Scalars['ID']
};


export type ReviewTagsQuery = ({ readonly __typename: 'Query' } & { readonly review: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & (({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & Pick<Node, 'id'>) & ({ readonly __typename: 'Review' } & { readonly tags: ReadonlyArray<({ readonly __typename: 'Tag' } & Pick<Tag, 'id' | 'isDeleteable' | 'name'>)> })))> });

export type CreateTagMutationVariables = {
  reviewId: Scalars['ID'],
  name: Scalars['String']
};


export type CreateTagMutation = ({ readonly __typename: 'Mutation' } & { readonly createTag: Maybe<({ readonly __typename: 'CreateTagPayload' } & Pick<CreateTagPayload, 'success'> & { readonly tag: Maybe<({ readonly __typename: 'Tag' } & Pick<Tag, 'id' | 'name' | 'isDeleteable'>)> })> });

export type DeleteTagMutationVariables = {
  id: Scalars['ID']
};


export type DeleteTagMutation = ({ readonly __typename: 'Mutation' } & { readonly deleteTag: Maybe<({ readonly __typename: 'DeleteTagPayload' } & Pick<DeleteTagPayload, 'success'>)> });

export type MyCochraneReviewsQueryVariables = {};


export type MyCochraneReviewsQuery = ({ readonly __typename: 'Query' } & { readonly cochrane: ({ readonly __typename: 'Cochrane' } & { readonly reviews: ({ readonly __typename: 'CochraneReviewConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'CochraneReview' } & Pick<CochraneReview, 'id' | 'cochraneId' | 'title'> & { readonly link: Maybe<({ readonly __typename: 'CochraneReviewLink' } & { readonly covidenceReview: ({ readonly __typename: 'Review' } & Pick<Review, 'id'>) })> })>>> }) }) });

export type CreateLinkedCochraneReviewMutationVariables = {
  accountId: Scalars['ID'],
  cochraneReviewId: Scalars['ID'],
  enableRctClassifier?: Maybe<Scalars['Boolean']>,
  enableRctAutoExclusion?: Maybe<Scalars['Boolean']>
};


export type CreateLinkedCochraneReviewMutation = ({ readonly __typename: 'Mutation' } & { readonly createLinkedCochraneReview: Maybe<({ readonly __typename: 'CreateLinkedCochraneReviewPayload' } & Pick<CreateLinkedCochraneReviewPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>>, readonly review: Maybe<({ readonly __typename: 'Review' } & Pick<Review, 'id' | 'title'>)> })> });

export type CreateReviewMutationVariables = {
  accountId: Scalars['ID'],
  title: Scalars['String'],
  reviewType: Scalars['String'],
  otherReviewTypeLabel?: Maybe<Scalars['String']>,
  questionType: Scalars['String'],
  otherQuestionTypeLabel?: Maybe<Scalars['String']>,
  researchArea: Scalars['String'],
  otherResearchAreaLabel?: Maybe<Scalars['String']>,
  enableRctClassifier?: Maybe<Scalars['Boolean']>,
  enableRctAutoExclusion?: Maybe<Scalars['Boolean']>
};


export type CreateReviewMutation = ({ readonly __typename: 'Mutation' } & { readonly createReview: Maybe<({ readonly __typename: 'CreateReviewPayload' } & Pick<CreateReviewPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>>, readonly review: Maybe<({ readonly __typename: 'Review' } & Pick<Review, 'id' | 'title'>)> })> });

export type AdministratorsDataSourceQueryVariables = {
  organizationId: Scalars['ID'],
  after?: Maybe<Scalars['String']>
};


export type AdministratorsDataSourceQuery = ({ readonly __typename: 'Query' } & { readonly organization: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Organization' } & { readonly administrators: ({ readonly __typename: 'UserConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'User' } & Pick<User, 'id' | 'name'> & { readonly email: User['primaryEmail'] } & { readonly organizationMembership: ({ readonly __typename: 'Membership' } & { readonly assignedReviews: ({ readonly __typename: 'ReviewConnection' } & Pick<ReviewConnection, 'total'>) }) })>>> }) }))> });

export type DemoteOrganizationAdministratorToMemberMutationVariables = {
  organizationId: Scalars['ID'],
  administratorId: Scalars['ID']
};


export type DemoteOrganizationAdministratorToMemberMutation = ({ readonly __typename: 'Mutation' } & { readonly demoteOrganizationAdministratorToMember: Maybe<({ readonly __typename: 'DemoteOrganizationAdministratorToMemberPayload' } & Pick<DemoteOrganizationAdministratorToMemberPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>>, readonly membership: Maybe<({ readonly __typename: 'Membership' } & Pick<Membership, 'id' | 'status'>)> })> });

export type PromoteOrganizationMemberToAdministratorMutationVariables = {
  organizationId: Scalars['ID'],
  memberId: Scalars['ID']
};


export type PromoteOrganizationMemberToAdministratorMutation = ({ readonly __typename: 'Mutation' } & { readonly promoteOrganizationMemberToAdministrator: Maybe<({ readonly __typename: 'PromoteOrganizationMemberToAdministratorPayload' } & Pick<PromoteOrganizationMemberToAdministratorPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>>, readonly membership: Maybe<({ readonly __typename: 'Membership' } & Pick<Membership, 'id' | 'status'>)> })> });

export type RevokeMembershipMutationVariables = {
  organizationId: Scalars['ID'],
  memberId: Scalars['ID']
};


export type RevokeMembershipMutation = ({ readonly __typename: 'Mutation' } & { readonly revokeMembership: Maybe<({ readonly __typename: 'RevokeMembershipPayload' } & Pick<RevokeMembershipPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>>, readonly membership: ({ readonly __typename: 'Membership' } & Pick<Membership, 'id' | 'status' | 'memberSince'>) })> });

export type ReviewsFragment = ({ readonly __typename: 'Membership' } & { readonly reviews: Maybe<({ readonly __typename: 'ReviewConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Review' } & Pick<Review, 'id' | 'title' | 'lastActivityAt'>)>>> })> });

export type GetReviewsQueryVariables = {
  authorId: Scalars['ID'],
  organizationId: Scalars['ID'],
  after?: Maybe<Scalars['String']>
};


export type GetReviewsQuery = ({ readonly __typename: 'Query' } & { readonly author: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & Pick<Node, 'id'> & ({ readonly __typename: 'User' } & { readonly membership: ({ readonly __typename: 'Membership' } & Pick<Membership, 'id'> & ReviewsFragment) }))> });

export type AssignedReviewsFragment = ({ readonly __typename: 'Membership' } & { readonly assignedReviews: ({ readonly __typename: 'ReviewConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Review' } & Pick<Review, 'id' | 'title' | 'lastActivityAt'>)>>> }) });

export type GetAssignedReviewsQueryVariables = {
  authorId: Scalars['ID'],
  organizationId: Scalars['ID'],
  after?: Maybe<Scalars['String']>
};


export type GetAssignedReviewsQuery = ({ readonly __typename: 'Query' } & { readonly author: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & Pick<Node, 'id'> & ({ readonly __typename: 'User' } & { readonly membership: ({ readonly __typename: 'Membership' } & Pick<Membership, 'id'> & AssignedReviewsFragment) }))> });

export type GetAuthorQueryVariables = {
  authorId: Scalars['ID'],
  organizationId: Scalars['ID'],
  after?: Maybe<Scalars['String']>
};


export type GetAuthorQuery = ({ readonly __typename: 'Query' } & { readonly me: Maybe<({ readonly __typename: 'User' } & Pick<User, 'id'>)>, readonly author: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & Pick<Node, 'id'> & ({ readonly __typename: 'User' } & Pick<User, 'name'> & { readonly email: User['primaryEmail'] } & { readonly membership: ({ readonly __typename: 'Membership' } & Pick<Membership, 'id' | 'status'> & { readonly invitation: Maybe<({ readonly __typename: 'Invitation' } & Pick<Invitation, 'id' | 'email' | 'expiresAt'>)> } & (ReviewsFragment & AssignedReviewsFragment)) }))>, readonly organization: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & Pick<Node, 'id'> & ({ readonly __typename: 'Organization' } & Pick<Organization, 'name'>))> });

export type InvitationsQueryVariables = {
  organizationId: Scalars['ID'],
  after?: Maybe<Scalars['String']>
};


export type InvitationsQuery = ({ readonly __typename: 'Query' } & { readonly organization: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Organization' } & { readonly invitations: ({ readonly __typename: 'InvitationConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Invitation' } & Pick<Invitation, 'id' | 'name' | 'email' | 'expiresAt'>)>>> }) }))> });

export type CancelInvitationMutationVariables = {
  invitationId: Scalars['ID']
};


export type CancelInvitationMutation = ({ readonly __typename: 'Mutation' } & { readonly cancelInvitation: Maybe<({ readonly __typename: 'CancelInvitationPayload' } & Pick<CancelInvitationPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type ExportOrganizationAuthorListMutationVariables = {
  organizationId: Scalars['ID'],
  filterAuthorsName?: Maybe<Scalars['String']>,
  sortDirection: SortDirection
};


export type ExportOrganizationAuthorListMutation = ({ readonly __typename: 'Mutation' } & { readonly exportOrganizationAuthorList: Maybe<({ readonly __typename: 'ExportOrganizationAuthorListPayload' } & Pick<ExportOrganizationAuthorListPayload, 'success'>)> });

export type AuthorsQueryVariables = {
  organizationId: Scalars['ID'],
  after?: Maybe<Scalars['String']>,
  filter?: Maybe<OrganizationAuthorsFilter>,
  sort?: Maybe<UserSort>,
  sortDirection?: Maybe<SortDirection>
};


export type AuthorsQuery = ({ readonly __typename: 'Query' } & { readonly organization: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & Pick<Node, 'id'> & ({ readonly __typename: 'Organization' } & { readonly authors: ({ readonly __typename: 'UserConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'User' } & Pick<User, 'id' | 'name'> & { readonly email: User['primaryEmail'] } & { readonly membership: ({ readonly __typename: 'Membership' } & Pick<Membership, 'id' | 'status' | 'memberSince'> & { readonly organizationReviews: Maybe<({ readonly __typename: 'ReviewConnection' } & Pick<ReviewConnection, 'total'>)> }) })>>> }) }))> });

export type InvitePersonToOrganizationMutationVariables = {
  organizationId: Scalars['ID'],
  name: Scalars['String'],
  email: Scalars['Email'],
  resend?: Maybe<Scalars['Boolean']>
};


export type InvitePersonToOrganizationMutation = ({ readonly __typename: 'Mutation' } & { readonly invitePersonToOrganization: Maybe<({ readonly __typename: 'InvitePersonToOrganizationPayload' } & Pick<InvitePersonToOrganizationPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>>, readonly invitation: Maybe<({ readonly __typename: 'Invitation' } & Pick<Invitation, 'id' | 'name' | 'email' | 'expiresAt'>)> })> });

export type GetAuthorsExportQueryVariables = {
  organizationId: Scalars['ID']
};


export type GetAuthorsExportQuery = ({ readonly __typename: 'Query' } & { readonly organization: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Organization' } & { readonly exports: Maybe<ReadonlyArray<({ readonly __typename: 'AuthorExport' } & Pick<AuthorExport, 'id' | 'authenticatedUrl' | 'createdAt' | 'completedAt' | 'failed'>)>> }))> });

export type AssignAdminMutationVariables = {
  reviewId: Scalars['ID'],
  administratorId: Scalars['ID']
};


export type AssignAdminMutation = ({ readonly __typename: 'Mutation' } & { readonly assign: Maybe<({ readonly __typename: 'AssignOrganizationAdministratorToReviewPayload' } & Pick<AssignOrganizationAdministratorToReviewPayload, 'success'> & { readonly review: Maybe<({ readonly __typename: 'Review' } & Pick<Review, 'id'> & { readonly assignedAdministrator: Maybe<({ readonly __typename: 'User' } & Pick<User, 'id' | 'name'> & { readonly email: User['primaryEmail'] })> })>, readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type UnassignAdminMutationVariables = {
  reviewId: Scalars['ID']
};


export type UnassignAdminMutation = ({ readonly __typename: 'Mutation' } & { readonly assign: Maybe<({ readonly __typename: 'UnassignOrganizationAdministratorFromReviewPayload' } & Pick<UnassignOrganizationAdministratorFromReviewPayload, 'success'> & { readonly review: Maybe<({ readonly __typename: 'Review' } & Pick<Review, 'id'> & { readonly assignedAdministrator: Maybe<({ readonly __typename: 'User' } & Pick<User, 'id' | 'name'> & { readonly email: User['primaryEmail'] })> })>, readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type AdministratorFragment = ({ readonly __typename: 'User' } & Pick<User, 'id' | 'name'> & { readonly email: User['primaryEmail'] });

export type AdministratorsQueryVariables = {
  organizationId: Scalars['ID']
};


export type AdministratorsQuery = ({ readonly __typename: 'Query' } & { readonly organization: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Organization' } & { readonly administrators: ({ readonly __typename: 'UserConnection' } & { readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'User' } & AdministratorFragment)>>> }) }))> });

export type ReviewsQueryVariables = {
  organizationId: Scalars['ID'],
  after?: Maybe<Scalars['String']>,
  filter?: Maybe<OrganizationReviewsFilter>,
  sort?: Maybe<ReviewSort>,
  sortDirection?: Maybe<SortDirection>
};


export type ReviewsQuery = ({ readonly __typename: 'Query' } & { readonly organization: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Organization' } & { readonly reviews: ({ readonly __typename: 'ReviewConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Review' } & Pick<Review, 'id' | 'title' | 'lastActivityAt'> & { readonly collaborators: ({ readonly __typename: 'UserConnection' } & Pick<UserConnection, 'total'>), readonly assignedAdministrator: Maybe<({ readonly __typename: 'User' } & Pick<User, 'id' | 'name'>)> })>>> }) }))> });

export type ProfileDataQueryVariables = {};


export type ProfileDataQuery = ({ readonly __typename: 'Query' } & { readonly me: Maybe<({ readonly __typename: 'User' } & { readonly consent: ({ readonly __typename: 'UserConsent' } & Pick<UserConsent, 'decision'>) })> });

export type AdminOrganizationInvitationsQueryVariables = {
  organizationId: Scalars['ID'],
  after?: Maybe<Scalars['String']>,
  filter?: Maybe<OrganizationInvitationsFilter>
};


export type AdminOrganizationInvitationsQuery = ({ readonly __typename: 'Query' } & { readonly organization: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & Pick<Node, 'id'> & ({ readonly __typename: 'Organization' } & { readonly invitations: ({ readonly __typename: 'InvitationConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Invitation' } & Pick<Invitation, 'id' | 'email' | 'name' | 'expiresAt'>)>>> }) }))> });

export type AdminDeleteOrganizationInvitationMutationVariables = {
  invitationId: Scalars['ID']
};


export type AdminDeleteOrganizationInvitationMutation = ({ readonly __typename: 'Mutation' } & { readonly cancelInvitation: Maybe<({ readonly __typename: 'CancelInvitationPayload' } & Pick<CancelInvitationPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type AdminResendOrganizationInvitationMutationVariables = {
  organizationId: Scalars['ID'],
  name: Scalars['String'],
  email: Scalars['Email']
};


export type AdminResendOrganizationInvitationMutation = ({ readonly __typename: 'Mutation' } & { readonly invitePersonToOrganization: Maybe<({ readonly __typename: 'InvitePersonToOrganizationPayload' } & Pick<InvitePersonToOrganizationPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>>, readonly invitation: Maybe<({ readonly __typename: 'Invitation' } & Pick<Invitation, 'id' | 'name' | 'email' | 'expiresAt'>)> })> });

export type AdminOrganizationMembersQueryVariables = {
  organizationId: Scalars['ID'],
  after?: Maybe<Scalars['String']>,
  filter?: Maybe<OrganizationMembershipsFilter>
};


export type AdminOrganizationMembersQuery = ({ readonly __typename: 'Query' } & { readonly organization: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & Pick<Node, 'id'> & ({ readonly __typename: 'Organization' } & { readonly memberships: ({ readonly __typename: 'MembershipConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Membership' } & Pick<Membership, 'id' | 'status' | 'memberSince'> & { readonly member: ({ readonly __typename: 'User' } & Pick<User, 'dbId' | 'id' | 'name'>) })>>> }) }))> });

export type AdminRevokeMembershipMutationVariables = {
  organizationId: Scalars['ID'],
  memberId: Scalars['ID']
};


export type AdminRevokeMembershipMutation = ({ readonly __typename: 'Mutation' } & { readonly revokeMembership: Maybe<({ readonly __typename: 'RevokeMembershipPayload' } & Pick<RevokeMembershipPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type AdminPromoteOrganizationMemberMutationVariables = {
  organizationId: Scalars['ID'],
  memberId: Scalars['ID']
};


export type AdminPromoteOrganizationMemberMutation = ({ readonly __typename: 'Mutation' } & { readonly promoteOrganizationMemberToAdministrator: Maybe<({ readonly __typename: 'PromoteOrganizationMemberToAdministratorPayload' } & Pick<PromoteOrganizationMemberToAdministratorPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>>, readonly membership: Maybe<({ readonly __typename: 'Membership' } & Pick<Membership, 'id' | 'status'>)> })> });

export type AdminDemoteOrganizationMemberMutationVariables = {
  organizationId: Scalars['ID'],
  memberId: Scalars['ID']
};


export type AdminDemoteOrganizationMemberMutation = ({ readonly __typename: 'Mutation' } & { readonly demoteOrganizationAdministratorToMember: Maybe<({ readonly __typename: 'DemoteOrganizationAdministratorToMemberPayload' } & Pick<DemoteOrganizationAdministratorToMemberPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>>, readonly membership: Maybe<({ readonly __typename: 'Membership' } & Pick<Membership, 'id' | 'status'>)> })> });

export type AdminAccountReviewsQueryVariables = {
  organizationId: Scalars['ID'],
  after?: Maybe<Scalars['String']>,
  filter?: Maybe<OrganizationReviewsFilter>,
  sort?: Maybe<ReviewSort>,
  sortDirection?: Maybe<SortDirection>
};


export type AdminAccountReviewsQuery = ({ readonly __typename: 'Query' } & { readonly organization: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Organization' } & Pick<Organization, 'id'> & { readonly reviews: ({ readonly __typename: 'ReviewConnection' } & AccountReviewsFragment) }))> });

export type AccountReviewsFragment = ({ readonly __typename: 'ReviewConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Review' } & Pick<Review, 'id' | 'dbId' | 'title' | 'lastActivityAt' | 'createdAt' | 'deletedAt'> & { readonly creator: ({ readonly __typename: 'User' } & Pick<User, 'id' | 'dbId' | 'name'>), readonly cochraneReviewLink: Maybe<({ readonly __typename: 'CochraneReviewLink' } & Pick<CochraneReviewLink, 'id'>)> })>>> });

export type ChangeStudyIdentifierMutationVariables = {
  studyId: Scalars['ID'],
  newStudyIdentifier: Scalars['String']
};


export type ChangeStudyIdentifierMutation = ({ readonly __typename: 'Mutation' } & { readonly changeStudyIdentifier: Maybe<({ readonly __typename: 'ChangeStudyIdentifierPayload' } & Pick<ChangeStudyIdentifierPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>>, readonly study: Maybe<({ readonly __typename: 'Study' } & Pick<Study, 'id' | 'studyId'>)> })> });

export type AdminReviewStudiesQueryVariables = {
  reviewId: Scalars['ID'],
  after?: Maybe<Scalars['String']>,
  filter?: Maybe<StudiesFilter>
};


export type AdminReviewStudiesQuery = ({ readonly __typename: 'Query' } & { readonly review: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Review' } & { readonly studies: ({ readonly __typename: 'StudyConnection' } & ReviewStudiesFragment) }))> });

export type ReviewStudiesFragment = ({ readonly __typename: 'StudyConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Study' } & Pick<Study, 'id' | 'covidenceNumber' | 'studyId' | 'title'>)>>> });

export type AddNoteToStudyMutationVariables = {
  input: AddNoteToStudyInput
};


export type AddNoteToStudyMutation = ({ readonly __typename: 'Mutation' } & { readonly addNoteToStudy: Maybe<({ readonly __typename: 'AddNoteToStudyPayload' } & Pick<AddNoteToStudyPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type GenerateSignedUploadUrlMutationVariables = {
  referenceId: Scalars['ID'],
  filename: Scalars['String']
};


export type GenerateSignedUploadUrlMutation = ({ readonly __typename: 'Mutation' } & { readonly generateSignedUploadUrl: Maybe<({ readonly __typename: 'GenerateSignedUploadUrlPayload' } & Pick<GenerateSignedUploadUrlPayload, 'success' | 'url'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type AddUploadedDocumentMutationVariables = {
  referenceId: Scalars['ID'],
  filename: Scalars['String']
};


export type AddUploadedDocumentMutation = ({ readonly __typename: 'Mutation' } & { readonly addUploadedDocument: Maybe<({ readonly __typename: 'AddUploadedDocumentPayload' } & Pick<AddUploadedDocumentPayload, 'success'> & { readonly documents: Maybe<ReadonlyArray<({ readonly __typename: 'Document' } & Pick<Document, 'id' | 'fileName' | 'url' | 'primaryDocument'>)>>, readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type EditNoteMutationVariables = {
  input: EditNoteInput
};


export type EditNoteMutation = ({ readonly __typename: 'Mutation' } & { readonly editNote: Maybe<({ readonly __typename: 'EditNotePayload' } & Pick<EditNotePayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type MergeStudiesMutationVariables = {
  input: MergeStudiesInput
};


export type MergeStudiesMutation = ({ readonly __typename: 'Mutation' } & { readonly mergeStudies: Maybe<({ readonly __typename: 'MergeStudiesPayload' } & Pick<MergeStudiesPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type DeleteDocumentMutationVariables = {
  documentId: Scalars['ID']
};


export type DeleteDocumentMutation = ({ readonly __typename: 'Mutation' } & { readonly deleteDocument: Maybe<({ readonly __typename: 'DeleteDocumentPayload' } & Pick<DeleteDocumentPayload, 'success'>)> });

export type MarkDocumentAsPrimaryMutationVariables = {
  documentId: Scalars['ID']
};


export type MarkDocumentAsPrimaryMutation = ({ readonly __typename: 'Mutation' } & { readonly markDocumentAsPrimary: Maybe<({ readonly __typename: 'MarkDocumentAsPrimaryPayload' } & Pick<MarkDocumentAsPrimaryPayload, 'success'> & { readonly documents: ReadonlyArray<({ readonly __typename: 'Document' } & Pick<Document, 'id' | 'fileName' | 'url' | 'primaryDocument'>)> })> });

export type RemoveNoteMutationVariables = {
  input: RemoveNoteInput
};


export type RemoveNoteMutation = ({ readonly __typename: 'Mutation' } & { readonly removeNote: Maybe<({ readonly __typename: 'RemoveNotePayload' } & Pick<RemoveNotePayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type SelectableReviewersQueryVariables = {
  id: Scalars['ID']
};


export type SelectableReviewersQuery = ({ readonly __typename: 'Query' } & { readonly review: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Review' } & { readonly memberships: ({ readonly __typename: 'ReviewMembershipConnection' } & { readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'ReviewMembership' } & { readonly reviewer: ({ readonly __typename: 'User' } & Pick<User, 'id' | 'name'>) })>>> }) }))> });

export type ReassignStudyReviewerMutationVariables = {
  studyId: Scalars['ID'],
  extractorReassignments?: Maybe<ReadonlyArray<Maybe<ExtractionReassignment>>>,
  consensusReassignment?: Maybe<ConsensusReassignment>
};


export type ReassignStudyReviewerMutation = ({ readonly __typename: 'Mutation' } & { readonly reassignStudyReviewer: Maybe<({ readonly __typename: 'ReassignStudyReviewerPayload' } & Pick<ReassignStudyReviewerPayload, 'success'> & { readonly progress: ({ readonly __typename: 'ExtractionProgress' } & Pick<ExtractionProgress, 'status'> & { readonly extractionSlots: ReadonlyArray<({ readonly __typename: 'ExtractionSlot' } & Pick<ExtractionSlot, 'assigned' | 'currentUser' | 'lastActivityAgo' | 'completed'> & { readonly extractor: Maybe<({ readonly __typename: 'ExtractionSlotUser' } & Pick<ExtractionSlotUser, 'id' | 'name'>)> })>, readonly consensusSlot: Maybe<({ readonly __typename: 'ConsensusSlot' } & Pick<ConsensusSlot, 'assigned' | 'currentUser' | 'lastActivityAgo' | 'started' | 'completed'> & { readonly decider: Maybe<({ readonly __typename: 'ExtractionSlotUser' } & Pick<ExtractionSlotUser, 'id' | 'name'>)> })> }) })> });

export type UnmergeStudiesMutationVariables = {
  input: UnmergeStudiesInput
};


export type UnmergeStudiesMutation = ({ readonly __typename: 'Mutation' } & { readonly unmergeStudies: Maybe<({ readonly __typename: 'UnmergeStudiesPayload' } & Pick<UnmergeStudiesPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type GetCommentQueryVariables = {
  id: Scalars['ID']
};


export type GetCommentQuery = ({ readonly __typename: 'Query' } & { readonly comment: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Comment' } & Pick<Comment, 'id' | 'content' | 'createdAgo' | 'activeAgo' | 'editedAgo' | 'resolvedAgo'> & { readonly mentions: ReadonlyArray<({ readonly __typename: 'CommentMention' } & Pick<CommentMention, 'name' | 'replied'>)>, readonly activeBy: ({ readonly __typename: 'User' } & Pick<User, 'name'>), readonly reviewer: ({ readonly __typename: 'User' } & Pick<User, 'name'>), readonly reviewStudies: ReadonlyArray<({ readonly __typename: 'Study' } & Pick<Study, 'id' | 'title' | 'authors' | 'studyId' | 'covidenceNumber'> & { readonly references: ({ readonly __typename: 'ReportConnection' } & { readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Report' } & Pick<Report, 'abstract' | 'journalInfo' | 'publisherInfo'> & { readonly documents: Maybe<ReadonlyArray<({ readonly __typename: 'Document' } & Pick<Document, 'id' | 'url' | 'fileName'>)>> })>>> }) })>, readonly actions: ({ readonly __typename: 'CommentActions' } & Pick<CommentActions, 'canResolve' | 'canEdit'>), readonly replies: Maybe<ReadonlyArray<({ readonly __typename: 'Comment' } & Pick<Comment, 'id' | 'content' | 'createdAgo' | 'editedAgo'> & { readonly reviewer: ({ readonly __typename: 'User' } & Pick<User, 'name'>), readonly actions: ({ readonly __typename: 'CommentActions' } & Pick<CommentActions, 'canEdit'>) })>> }))> });

export type AddReplyToCommentMutationVariables = {
  input: AddReplyToCommentInput
};


export type AddReplyToCommentMutation = ({ readonly __typename: 'Mutation' } & { readonly addReplyToComment: Maybe<({ readonly __typename: 'AddReplyToCommentPayload' } & Pick<AddReplyToCommentPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type EditCommentMutationVariables = {
  input: EditCommentInput
};


export type EditCommentMutation = ({ readonly __typename: 'Mutation' } & { readonly editComment: Maybe<({ readonly __typename: 'EditCommentPayload' } & Pick<EditCommentPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type ResolveDiscussionMutationVariables = {
  input: ResolveDiscussionInput
};


export type ResolveDiscussionMutation = ({ readonly __typename: 'Mutation' } & { readonly resolveDiscussion: Maybe<({ readonly __typename: 'ResolveDiscussionPayload' } & Pick<ResolveDiscussionPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type GetCommentsQueryVariables = {
  filter: CommentsFilter,
  sort?: Maybe<CommentSort>,
  after?: Maybe<Scalars['String']>
};


export type GetCommentsQuery = ({ readonly __typename: 'Query' } & { readonly comments: Maybe<({ readonly __typename: 'CommentConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Comment' } & Pick<Comment, 'id' | 'content' | 'createdAgo' | 'activeAgo'> & { readonly mentions: ReadonlyArray<({ readonly __typename: 'CommentMention' } & Pick<CommentMention, 'name' | 'replied'>)>, readonly activeBy: ({ readonly __typename: 'User' } & Pick<User, 'name'>), readonly reviewer: ({ readonly __typename: 'User' } & Pick<User, 'name'>), readonly reviewStudies: ReadonlyArray<({ readonly __typename: 'Study' } & Pick<Study, 'id' | 'title' | 'authors' | 'studyId' | 'covidenceNumber'> & { readonly references: ({ readonly __typename: 'ReportConnection' } & { readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Report' } & Pick<Report, 'abstract' | 'journalInfo' | 'publisherInfo'> & { readonly documents: Maybe<ReadonlyArray<({ readonly __typename: 'Document' } & Pick<Document, 'id' | 'url' | 'fileName'>)>> })>>> }) })>, readonly actions: ({ readonly __typename: 'CommentActions' } & Pick<CommentActions, 'showUrl'>) })>>> })> });

export type CreateExtractionFormRevisionMutationVariables = {
  extractionFormRevision: CreateExtractionFormRevisionInput
};


export type CreateExtractionFormRevisionMutation = ({ readonly __typename: 'Mutation' } & { readonly createExtractionFormRevision: Maybe<({ readonly __typename: 'CreateExtractionFormRevisionPayload' } & Pick<CreateExtractionFormRevisionPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type CompleteExtractionFormMutationVariables = {
  extractionFormRevision: CompleteExtractionFormInput
};


export type CompleteExtractionFormMutation = ({ readonly __typename: 'Mutation' } & { readonly completeExtractionForm: Maybe<({ readonly __typename: 'CompleteExtractionFormPayload' } & Pick<CompleteExtractionFormPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type RevertTemplateMutationVariables = {
  params: RevertTemplateInput
};


export type RevertTemplateMutation = ({ readonly __typename: 'Mutation' } & { readonly response: Maybe<({ readonly __typename: 'RevertTemplatePayload' } & Pick<RevertTemplatePayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type SaveConsensusMutationVariables = {
  input: SaveConsensusInput
};


export type SaveConsensusMutation = ({ readonly __typename: 'Mutation' } & { readonly saveConsensus: Maybe<({ readonly __typename: 'SaveConsensusPayload' } & Pick<SaveConsensusPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type CompleteConsensusMutationVariables = {
  input: CompleteConsensusInput
};


export type CompleteConsensusMutation = ({ readonly __typename: 'Mutation' } & { readonly completeConsensus: Maybe<({ readonly __typename: 'CompleteConsensusPayload' } & Pick<CompleteConsensusPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type SaveExtractedDataMutationVariables = {
  input: SaveExtractedDataInput
};


export type SaveExtractedDataMutation = ({ readonly __typename: 'Mutation' } & { readonly saveExtractedData: Maybe<({ readonly __typename: 'SaveExtractedDataPayload' } & Pick<SaveExtractedDataPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type CompleteExtractedDataMutationVariables = {
  input: CompleteExtractedDataInput
};


export type CompleteExtractedDataMutation = ({ readonly __typename: 'Mutation' } & { readonly completeExtractedData: Maybe<({ readonly __typename: 'CompleteExtractedDataPayload' } & Pick<CompleteExtractedDataPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type StudyListQueryVariables = {
  id: Scalars['ID'],
  count: Scalars['Int'],
  sort?: Maybe<ExtractionStudySort>,
  after?: Maybe<Scalars['String']>,
  filter?: Maybe<ExtractionStudiesFilter>,
  filterByTags?: Maybe<ReadonlyArray<Scalars['String']>>,
  studyId?: Maybe<Scalars['ID']>
};


export type StudyListQuery = ({ readonly __typename: 'Query' } & { readonly review: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Review' } & { readonly tags: ReadonlyArray<({ readonly __typename: 'Tag' } & Pick<Tag, 'name'>)>, readonly studies: ({ readonly __typename: 'ExtractionStudyConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'ExtractionStudy' } & Pick<ExtractionStudy, 'id' | 'studyId' | 'tags' | 'covidenceNumber' | 'title' | 'authors'> & { readonly notes: ReadonlyArray<({ readonly __typename: 'Note' } & Pick<Note, 'id' | 'note' | 'createdAt' | 'updatedAt'> & { readonly author: ({ readonly __typename: 'NoteAuthor' } & Pick<NoteAuthor, 'id' | 'name'>) })>, readonly references: ({ readonly __typename: 'ReportConnection' } & { readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Report' } & Pick<Report, 'id' | 'title' | 'authors' | 'fullText' | 'referenceUrl' | 'source' | 'publisherInfo' | 'journalInfo'> & { readonly documents: Maybe<ReadonlyArray<({ readonly __typename: 'Document' } & Pick<Document, 'id' | 'primaryDocument' | 'url' | 'fileName'>)>> })>>> }), readonly actions: ({ readonly __typename: 'StudyActions' } & Pick<StudyActions, 'extractUrl' | 'compareUrl' | 'editCompareUrl'>), readonly progress: ({ readonly __typename: 'ExtractionProgress' } & Pick<ExtractionProgress, 'status'> & { readonly consensusSlot: Maybe<({ readonly __typename: 'ConsensusSlot' } & Pick<ConsensusSlot, 'assigned' | 'currentUser' | 'lastActivityAgo' | 'started' | 'completed'> & { readonly decider: Maybe<({ readonly __typename: 'ExtractionSlotUser' } & Pick<ExtractionSlotUser, 'id' | 'name'>)> })>, readonly extractionSlots: ReadonlyArray<({ readonly __typename: 'ExtractionSlot' } & Pick<ExtractionSlot, 'assigned' | 'currentUser' | 'lastActivityAgo' | 'completed'> & { readonly extractor: Maybe<({ readonly __typename: 'ExtractionSlotUser' } & Pick<ExtractionSlotUser, 'id' | 'name'>)> })> }) })>>> }) }))> });

export type MoveStudyToFullTextMutationVariables = {
  input: RecordStudyVoteInput
};


export type MoveStudyToFullTextMutation = ({ readonly __typename: 'Mutation' } & { readonly recordStudyVote: Maybe<({ readonly __typename: 'RecordStudyVotePayload' } & Pick<RecordStudyVotePayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type GetTopicExpertInvitesQueryVariables = {
  guidelineId: Scalars['ID'],
  after?: Maybe<Scalars['String']>
};


export type GetTopicExpertInvitesQuery = ({ readonly __typename: 'Query' } & { readonly guideline: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & Pick<Node, 'id'> & ({ readonly __typename: 'Guideline' } & Pick<Guideline, 'id' | 'name'> & { readonly topics: Maybe<({ readonly __typename: 'TopicConnection' } & { readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Topic' } & Pick<Topic, 'id' | 'name'>)>>> })>, readonly topicExpertInvites: Maybe<({ readonly __typename: 'TopicExpertInviteConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'TopicExpertInvite' } & Pick<TopicExpertInvite, 'id' | 'createdAt' | 'name' | 'email'> & { readonly expertTopics: ReadonlyArray<({ readonly __typename: 'Topic' } & Pick<Topic, 'id' | 'name'>)> })>>> })> }))> });

export type InviteTopicExpertMutationVariables = {
  input: InviteTopicExpertInput
};


export type InviteTopicExpertMutation = ({ readonly __typename: 'Mutation' } & { readonly inviteTopicExpert: Maybe<({ readonly __typename: 'InviteTopicExpertPayload' } & Pick<InviteTopicExpertPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type CancelTopicExpertInviteMutationVariables = {
  input: CancelTopicExpertInviteInput
};


export type CancelTopicExpertInviteMutation = ({ readonly __typename: 'Mutation' } & { readonly cancelTopicExpertInvite: Maybe<({ readonly __typename: 'CancelTopicExpertInvitePayload' } & Pick<CancelTopicExpertInvitePayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type ResendTopicExpertInviteMutationVariables = {
  input: ResendTopicExpertInviteInput
};


export type ResendTopicExpertInviteMutation = ({ readonly __typename: 'Mutation' } & { readonly resendTopicExpertInvite: Maybe<({ readonly __typename: 'ResendTopicExpertInvitePayload' } & Pick<ResendTopicExpertInvitePayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type GetTopicExpertsQueryVariables = {
  guidelineId: Scalars['ID']
};


export type GetTopicExpertsQuery = ({ readonly __typename: 'Query' } & { readonly guideline: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & Pick<Node, 'id'> & ({ readonly __typename: 'Guideline' } & Pick<Guideline, 'id' | 'name'> & { readonly actions: ({ readonly __typename: 'GuidelineActions' } & Pick<GuidelineActions, 'canInviteTopicExpert' | 'inviteTopicExpertUrl'>), readonly topicExperts: Maybe<({ readonly __typename: 'TopicExpertConnection' } & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'TopicExpert' } & Pick<TopicExpert, 'id' | 'name' | 'email'> & { readonly expertTopics: ReadonlyArray<({ readonly __typename: 'Topic' } & Pick<Topic, 'id' | 'name'>)> })>>> })> }))> });

export type DeleteTopicExpertMutationVariables = {
  input: DeleteTopicExpertInput
};


export type DeleteTopicExpertMutation = ({ readonly __typename: 'Mutation' } & { readonly deleteTopicExpert: Maybe<({ readonly __typename: 'DeleteTopicExpertPayload' } & Pick<DeleteTopicExpertPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type OrganizationOverviewCountsQueryVariables = {
  organizationId: Scalars['ID']
};


export type OrganizationOverviewCountsQuery = ({ readonly __typename: 'Query' } & { readonly organization: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & Pick<Node, 'id'> & ({ readonly __typename: 'Organization' } & { readonly reviews: ({ readonly __typename: 'ReviewConnection' } & Pick<ReviewConnection, 'total'>), readonly authors: ({ readonly __typename: 'UserConnection' } & Pick<UserConnection, 'total'>), readonly unassignedReviews: ({ readonly __typename: 'ReviewConnection' } & Pick<ReviewConnection, 'total'>) }))> });

export type OrganizationReviewsSearchQueryVariables = {
  organizationId: Scalars['ID'],
  q: Scalars['String'],
  after?: Maybe<Scalars['String']>
};


export type OrganizationReviewsSearchQuery = ({ readonly __typename: 'Query' } & { readonly organization: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & Pick<Node, 'id'> & ({ readonly __typename: 'Organization' } & { readonly reviews: ({ readonly __typename: 'ReviewConnection' } & Pick<ReviewConnection, 'total'> & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Review' } & Pick<Review, 'id' | 'title' | 'lastActivityAt'> & { readonly collaborators: ({ readonly __typename: 'UserConnection' } & Pick<UserConnection, 'total'>), readonly assignedAdministrator: Maybe<({ readonly __typename: 'User' } & Pick<User, 'name'>)> })>>> }) }))> });

export type OrganizationAuthorsSearchQueryVariables = {
  organizationId: Scalars['ID'],
  q: Scalars['String'],
  after?: Maybe<Scalars['String']>
};


export type OrganizationAuthorsSearchQuery = ({ readonly __typename: 'Query' } & { readonly organization: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & Pick<Node, 'id'> & ({ readonly __typename: 'Organization' } & { readonly authors: ({ readonly __typename: 'UserConnection' } & Pick<UserConnection, 'total'> & { readonly pageInfo: ({ readonly __typename: 'PageInfo' } & Pick<PageInfo, 'hasNextPage' | 'endCursor'>), readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'User' } & Pick<User, 'id' | 'name' | 'primaryEmail'> & { readonly organizationMembership: ({ readonly __typename: 'Membership' } & Pick<Membership, 'status' | 'memberSince'> & { readonly organizationReviews: Maybe<({ readonly __typename: 'ReviewConnection' } & Pick<ReviewConnection, 'total'>)> }) })>>> }) }))> });

export type CreateCommentMutationVariables = {
  input: CreateCommentInput
};


export type CreateCommentMutation = ({ readonly __typename: 'Mutation' } & { readonly createComment: Maybe<({ readonly __typename: 'CreateCommentPayload' } & Pick<CreateCommentPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type GetCountsQueryVariables = {
  reviewId: Scalars['ID']
};


export type GetCountsQuery = ({ readonly __typename: 'Query' } & { readonly review: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Review' } & { readonly categoryCounts: ({ readonly __typename: 'CategoryCounts' } & Pick<CategoryCounts, 'screen' | 'select' | 'included' | 'excluded' | 'irrelevant' | 'excluded'>), readonly statistics: ({ readonly __typename: 'Statistics' } & { readonly screen: ({ readonly __typename: 'DetailedStatistics' } & StatsFragmentFragment), readonly select: ({ readonly __typename: 'DetailedStatistics' } & StatsFragmentFragment), readonly included: ({ readonly __typename: 'DetailedStatistics' } & StatsFragmentFragment) }) }))> });

export type StatsFragmentFragment = ({ readonly __typename: 'DetailedStatistics' } & Pick<DetailedStatistics, 'complete' | 'partiallyComplete' | 'consensusRequired' | 'available' | 'notStarted' | 'contribution'>);

export type ImportFragment = ({ readonly __typename: 'Import' } & Pick<Import, 'id' | 'defaultCategory' | 'state' | 'isFinished' | 'source' | 'createdAt' | 'importedStudiesCount' | 'detectedCitationsCount' | 'duplicateCitationsCount'> & { readonly error: Maybe<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)> });

export type ImportActivityQueryVariables = {
  reviewId: Scalars['ID']
};


export type ImportActivityQuery = ({ readonly __typename: 'Query' } & { readonly review: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Review' } & { readonly duplicates: ({ readonly __typename: 'DuplicateConnection' } & Pick<DuplicateConnection, 'totalDuplicates'>), readonly currentImport: Maybe<({ readonly __typename: 'Import' } & ImportFragment)>, readonly imports: ({ readonly __typename: 'ImportConnection' } & { readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Import' } & ImportFragment)>>> }) }))> });

export type GetPendingReviewsQueryVariables = {
  reviewId: Scalars['ID']
};


export type GetPendingReviewsQuery = ({ readonly __typename: 'Query' } & { readonly review: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Review' } & Pick<Review, 'enabledFeatures'> & { readonly cochraneReviewLink: Maybe<({ readonly __typename: 'CochraneReviewLink' } & Pick<CochraneReviewLink, 'crsPendingStudiesCount'>)>, readonly currentImport: Maybe<({ readonly __typename: 'Import' } & Pick<Import, 'id' | 'isFinished'>)> }))> });

export type ReviewCrsImportStatusQueryVariables = {
  reviewId: Scalars['ID']
};


export type ReviewCrsImportStatusQuery = ({ readonly __typename: 'Query' } & { readonly review: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Review' } & { readonly cochraneReviewLink: Maybe<({ readonly __typename: 'CochraneReviewLink' } & Pick<CochraneReviewLink, 'id' | 'crsPendingStudiesCount'>)> }))> });

export type InitiateCrsImportMutationVariables = {
  cochraneId: Scalars['ID']
};


export type InitiateCrsImportMutation = ({ readonly __typename: 'Mutation' } & { readonly initiateCrsImport: Maybe<({ readonly __typename: 'InitiateCRSImportPayload' } & Pick<InitiateCrsImportPayload, 'success'>)> });

export type ReviewersQueryQueryVariables = {
  reviewId: Scalars['ID']
};


export type ReviewersQueryQuery = ({ readonly __typename: 'Query' } & { readonly review: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Review' } & { readonly invites: ({ readonly __typename: 'InviteConnection' } & { readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Invite' } & Pick<Invite, 'id' | 'email' | 'name' | 'createdAt' | 'sentAt' | 'acceptedAt' | 'declinedAt' | 'expiresAt' | 'accepted' | 'expired' | 'declined' | 'pending'>)>>> }), readonly memberships: ({ readonly __typename: 'ReviewMembershipConnection' } & { readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'ReviewMembership' } & Pick<ReviewMembership, 'createdAt' | 'owner'> & { readonly reviewer: ({ readonly __typename: 'User' } & Pick<User, 'primaryEmail' | 'name' | 'id'>) })>>> }) }))> });

export type RemoveReviewerMutationVariables = {
  reviewId: Scalars['ID'],
  reviewerId: Scalars['ID']
};


export type RemoveReviewerMutation = ({ readonly __typename: 'Mutation' } & { readonly removeReviewer: Maybe<({ readonly __typename: 'RemoveReviewerPayload' } & Pick<RemoveReviewerPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type CancelReviewerInvitationMutationVariables = {
  invitationId: Scalars['ID']
};


export type CancelReviewerInvitationMutation = ({ readonly __typename: 'Mutation' } & { readonly cancelInvitation: Maybe<({ readonly __typename: 'CancelInvitationPayload' } & Pick<CancelInvitationPayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type ScreeningReviewQueryVariables = {
  reviewId: Scalars['ID']
};


export type ScreeningReviewQuery = ({ readonly __typename: 'Query' } & { readonly review: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Review' } & Pick<Review, 'id' | 'title' | 'includedKeywords' | 'excludedKeywords'>))> });

export type ReviewStudyScreeningQueryVariables = {
  reviewId: Scalars['ID'],
  reviewerId: Scalars['ID'],
  excludedStudyIds?: Maybe<ReadonlyArray<Scalars['ID']>>
};


export type ReviewStudyScreeningQuery = ({ readonly __typename: 'Query' } & { readonly review: Maybe<({ readonly __typename: 'CochraneReview' | 'CochraneReviewLink' | 'Review' | 'DuplicateCluster' | 'User' | 'Account' | 'Organization' | 'AuthorExport' | 'Invitation' | 'Membership' | 'Import' | 'ExtractionForm' | 'ExtractionFormRevision' | 'ExtractionStudy' | 'Note' | 'NoteAuthor' | 'Report' | 'Document' | 'Invite' | 'ReviewMembership' | 'Study' | 'Vote' | 'Tag' | 'Comment' | 'Guideline' | 'TopicExpertInvite' | 'Topic' | 'TopicExpert' | 'ConsensusRevision' | 'Consensus' | 'ExtractedDataRevision' | 'StudyExtractor' } & ({ readonly __typename: 'Review' } & Pick<Review, 'id' | 'title' | 'includedKeywords' | 'excludedKeywords'> & { readonly studiesAvailableForVoting: ReadonlyArray<({ readonly __typename: 'Study' } & Pick<Study, 'id' | 'covidenceNumber'> & { readonly references: ({ readonly __typename: 'ReportConnection' } & { readonly nodes: Maybe<ReadonlyArray<Maybe<({ readonly __typename: 'Report' } & Pick<Report, 'primaryAuthor' | 'title' | 'abstract'> & { readonly publication: Maybe<({ readonly __typename: 'Publication' } & Pick<Publication, 'year'>)> })>>> }) })> }))> });

export type ReviewStudyCastVoteMutationVariables = {
  studyId: Scalars['ID'],
  vote: VoteValue
};


export type ReviewStudyCastVoteMutation = ({ readonly __typename: 'Mutation' } & { readonly recordStudyVote: Maybe<({ readonly __typename: 'RecordStudyVotePayload' } & Pick<RecordStudyVotePayload, 'success'> & { readonly errors: Maybe<ReadonlyArray<({ readonly __typename: 'Error' } & Pick<Error, 'message'>)>> })> });

export type AddTagsToStudiesMutationVariables = {
  tags: ReadonlyArray<Scalars['String']>,
  studyIds: ReadonlyArray<Scalars['ID']>
};


export type AddTagsToStudiesMutation = ({ readonly __typename: 'Mutation' } & { readonly addTagsToStudies: Maybe<({ readonly __typename: 'AddTagsToStudiesPayload' } & Pick<AddTagsToStudiesPayload, 'success'>)> });

export type RemoveTagsFromStudiesMutationVariables = {
  tags: ReadonlyArray<Scalars['String']>,
  studyIds: ReadonlyArray<Scalars['ID']>
};


export type RemoveTagsFromStudiesMutation = ({ readonly __typename: 'Mutation' } & { readonly removeTagsFromStudies: Maybe<({ readonly __typename: 'RemoveTagsFromStudiesPayload' } & Pick<RemoveTagsFromStudiesPayload, 'success'>)> });
